import * as Types from './operations';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export const appleStatusResponseDataFragmentDoc = gql`
  fragment appleStatusResponseData on AppleCreditStatusResponse {
    status
    statusDetails
  }
`;
export const autoDebitRegistrationFragmentDoc = gql`
  fragment autoDebitRegistration on AutoDebitResponse {
    id
    status
    account {
      kind
      name
      number
      bankCode
      branchCode
      bankName
    }
    kfrequest
  }
`;
export const paymentDataFragmentDoc = gql`
  fragment paymentData on Payment {
    id
    storeName
    createdAt
    amount
    capturedAmount
    order {
      tax
      shipping
      items {
        title
        unitPrice
        quantity
        description
      }
    }
    byWayOf
    installmentPlanKind
    orderId
    subMerchantId
  }
`;
export const chargeDataOfBillStatementFragmentDoc = gql`
  fragment chargeDataOfBillStatement on Charge {
    id
    amount
    kind
    tier
    description
    pushedAt
    metadata {
      source
      settlementFeeAmount
      transactionId
      transactionItemId
      installmentPlanChargeKind
    }
    payment {
      ...paymentData
    }
  }
  ${paymentDataFragmentDoc}
`;
export const billStatementFragmentDoc = gql`
  fragment billStatement on BillStatement {
    id
    amount
    billingCycle
    unpaidAmount
    outstandingAmount
    lateFeeAmount
    currency
    period {
      start
      end
    }
    status
    statusV2
    dueAt
    paidAt
    combiniSettlementAvailable
    bankTransferSettlementAvailable
    lateFeeCharges {
      ...chargeDataOfBillStatement
    }
    autoDebitSettlement {
      pullAmount
      pullStatus
      resultsProcessedBy
    }
  }
  ${chargeDataOfBillStatementFragmentDoc}
`;
export const consumerBalanceSummaryFragmentDoc = gql`
  fragment consumerBalanceSummary on ConsumerBalanceSummary {
    billingCycle
    summaryPlus {
      nextMonthDue
      monthlyPower
      payableAmount
      balanceRatios {
        nextMonthDueRatio
        monthlyPowerRatio
      }
      singlePayAmount
    }
    consumerLimits {
      treLimit
      nmdLimit
    }
  }
`;
export const installmentPlanPaymentFragmentDoc = gql`
  fragment installmentPlanPayment on Payment {
    id
    storeName
    createdAt
    amount
    orderId
    subMerchantId
  }
`;
export const installmentPlanDataFragmentDoc = gql`
  fragment installmentPlanData on InstallmentPlan {
    id
    amount
    currency
    kind
    createdAt
    kind
    payment {
      ...paymentData
    }
    installments {
      id
      dueDate
      amount
      dueNext
    }
    status
  }
  ${paymentDataFragmentDoc}
`;
export const spendLimitDataFragmentDoc = gql`
  fragment spendLimitData on SpendLimit {
    max
    selected
  }
`;
export const transactionItemDataFragmentDoc = gql`
  fragment transactionItemData on TransactionItem {
    id
    title
    model
    size
    color
    unitPrice
    iconImage2x
    iconImage3x
    currency
    monthlyAmount
    planDuration
    itemKind
    orderNumber
    reductions {
      reductionType
      amount
    }
    clawbackType
  }
`;
export const transactionDataFragmentDoc = gql`
  fragment transactionData on Transaction {
    id
    totalAmount
    source
    items {
      ...transactionItemData
    }
    successUrl
    failureUrl
    returnUrl
    pendingUrl
  }
  ${transactionItemDataFragmentDoc}
`;
export const availableInstallmentPlanDataFragmentDoc = gql`
  fragment availableInstallmentPlanData on AvailableInstallmentPlanOptions {
    kind
    amount
    installments {
      id
      dueDate
      amount
    }
  }
`;
export const chargeDataFragmentDoc = gql`
  fragment chargeData on Charge {
    id
    amount
    kind
    tier
    description
    pushedAt
    metadata {
      source
      settlementFeeAmount
      byWayOf
      transactionId
      transactionItemId
      installmentPlanChargeKind
      appleClawbackType
    }
    payment {
      ...paymentData
    }
    installmentPlanOptions {
      available {
        ...availableInstallmentPlanData
      }
      unavailable {
        kind
        reason {
          threshold
          code
          details {
            kind
            installments {
              id
              amount
              dueDate
              dueNext
            }
          }
        }
      }
    }
  }
  ${paymentDataFragmentDoc}
  ${availableInstallmentPlanDataFragmentDoc}
`;
export const AppleCreditLimitUpgradeStatusDocument = gql`
  query AppleCreditLimitUpgradeStatus {
    AppleCreditLimitUpgradeStatus {
      status
    }
  }
`;

/**
 * __useAppleCreditLimitUpgradeStatusQuery__
 *
 * To run a query within a React component, call `useAppleCreditLimitUpgradeStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useAppleCreditLimitUpgradeStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAppleCreditLimitUpgradeStatusQuery({
 *   variables: {
 *   },
 * });
 */
export function useAppleCreditLimitUpgradeStatusQuery(
  baseOptions?: Apollo.QueryHookOptions<
    Types.AppleCreditLimitUpgradeStatusQuery,
    Types.AppleCreditLimitUpgradeStatusQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    Types.AppleCreditLimitUpgradeStatusQuery,
    Types.AppleCreditLimitUpgradeStatusQueryVariables
  >(AppleCreditLimitUpgradeStatusDocument, options);
}
export function useAppleCreditLimitUpgradeStatusLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    Types.AppleCreditLimitUpgradeStatusQuery,
    Types.AppleCreditLimitUpgradeStatusQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    Types.AppleCreditLimitUpgradeStatusQuery,
    Types.AppleCreditLimitUpgradeStatusQueryVariables
  >(AppleCreditLimitUpgradeStatusDocument, options);
}
export type AppleCreditLimitUpgradeStatusQueryHookResult = ReturnType<
  typeof useAppleCreditLimitUpgradeStatusQuery
>;
export type AppleCreditLimitUpgradeStatusLazyQueryHookResult = ReturnType<
  typeof useAppleCreditLimitUpgradeStatusLazyQuery
>;
export type AppleCreditLimitUpgradeStatusQueryResult = Apollo.QueryResult<
  Types.AppleCreditLimitUpgradeStatusQuery,
  Types.AppleCreditLimitUpgradeStatusQueryVariables
>;
export const AppleStatusDocument = gql`
  query AppleStatus {
    appleCreditStatus {
      ...appleStatusResponseData
    }
  }
  ${appleStatusResponseDataFragmentDoc}
`;

/**
 * __useAppleStatusQuery__
 *
 * To run a query within a React component, call `useAppleStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useAppleStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAppleStatusQuery({
 *   variables: {
 *   },
 * });
 */
export function useAppleStatusQuery(
  baseOptions?: Apollo.QueryHookOptions<
    Types.AppleStatusQuery,
    Types.AppleStatusQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    Types.AppleStatusQuery,
    Types.AppleStatusQueryVariables
  >(AppleStatusDocument, options);
}
export function useAppleStatusLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    Types.AppleStatusQuery,
    Types.AppleStatusQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    Types.AppleStatusQuery,
    Types.AppleStatusQueryVariables
  >(AppleStatusDocument, options);
}
export type AppleStatusQueryHookResult = ReturnType<typeof useAppleStatusQuery>;
export type AppleStatusLazyQueryHookResult = ReturnType<
  typeof useAppleStatusLazyQuery
>;
export type AppleStatusQueryResult = Apollo.QueryResult<
  Types.AppleStatusQuery,
  Types.AppleStatusQueryVariables
>;
export const ApproveTransactionDocument = gql`
  mutation ApproveTransaction($id: String!) {
    approveTransaction(id: $id) {
      status
    }
  }
`;
export type ApproveTransactionMutationFn = Apollo.MutationFunction<
  Types.ApproveTransactionMutation,
  Types.ApproveTransactionMutationVariables
>;

/**
 * __useApproveTransactionMutation__
 *
 * To run a mutation, you first call `useApproveTransactionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useApproveTransactionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [approveTransactionMutation, { data, loading, error }] = useApproveTransactionMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useApproveTransactionMutation(
  baseOptions?: Apollo.MutationHookOptions<
    Types.ApproveTransactionMutation,
    Types.ApproveTransactionMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    Types.ApproveTransactionMutation,
    Types.ApproveTransactionMutationVariables
  >(ApproveTransactionDocument, options);
}
export type ApproveTransactionMutationHookResult = ReturnType<
  typeof useApproveTransactionMutation
>;
export type ApproveTransactionMutationResult = Apollo.MutationResult<
  Types.ApproveTransactionMutation
>;
export type ApproveTransactionMutationOptions = Apollo.BaseMutationOptions<
  Types.ApproveTransactionMutation,
  Types.ApproveTransactionMutationVariables
>;
export const InitiateAuthVerificationDocument = gql`
  mutation InitiateAuthVerification(
    $scope: AuthVerificationScope!
    $pinCodeDispatchMethod: PinCodeDispatchMethod
  ) {
    initiateAuthVerification(
      scope: $scope
      pinCodeDispatchMethod: $pinCodeDispatchMethod
    )
  }
`;
export type InitiateAuthVerificationMutationFn = Apollo.MutationFunction<
  Types.InitiateAuthVerificationMutation,
  Types.InitiateAuthVerificationMutationVariables
>;

/**
 * __useInitiateAuthVerificationMutation__
 *
 * To run a mutation, you first call `useInitiateAuthVerificationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInitiateAuthVerificationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [initiateAuthVerificationMutation, { data, loading, error }] = useInitiateAuthVerificationMutation({
 *   variables: {
 *      scope: // value for 'scope'
 *      pinCodeDispatchMethod: // value for 'pinCodeDispatchMethod'
 *   },
 * });
 */
export function useInitiateAuthVerificationMutation(
  baseOptions?: Apollo.MutationHookOptions<
    Types.InitiateAuthVerificationMutation,
    Types.InitiateAuthVerificationMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    Types.InitiateAuthVerificationMutation,
    Types.InitiateAuthVerificationMutationVariables
  >(InitiateAuthVerificationDocument, options);
}
export type InitiateAuthVerificationMutationHookResult = ReturnType<
  typeof useInitiateAuthVerificationMutation
>;
export type InitiateAuthVerificationMutationResult = Apollo.MutationResult<
  Types.InitiateAuthVerificationMutation
>;
export type InitiateAuthVerificationMutationOptions = Apollo.BaseMutationOptions<
  Types.InitiateAuthVerificationMutation,
  Types.InitiateAuthVerificationMutationVariables
>;
export const ConfirmAuthVerificationDocument = gql`
  mutation ConfirmAuthVerification(
    $scope: AuthVerificationScope!
    $otp: String!
  ) {
    confirmAuthVerification(scope: $scope, otp: $otp)
  }
`;
export type ConfirmAuthVerificationMutationFn = Apollo.MutationFunction<
  Types.ConfirmAuthVerificationMutation,
  Types.ConfirmAuthVerificationMutationVariables
>;

/**
 * __useConfirmAuthVerificationMutation__
 *
 * To run a mutation, you first call `useConfirmAuthVerificationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useConfirmAuthVerificationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [confirmAuthVerificationMutation, { data, loading, error }] = useConfirmAuthVerificationMutation({
 *   variables: {
 *      scope: // value for 'scope'
 *      otp: // value for 'otp'
 *   },
 * });
 */
export function useConfirmAuthVerificationMutation(
  baseOptions?: Apollo.MutationHookOptions<
    Types.ConfirmAuthVerificationMutation,
    Types.ConfirmAuthVerificationMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    Types.ConfirmAuthVerificationMutation,
    Types.ConfirmAuthVerificationMutationVariables
  >(ConfirmAuthVerificationDocument, options);
}
export type ConfirmAuthVerificationMutationHookResult = ReturnType<
  typeof useConfirmAuthVerificationMutation
>;
export type ConfirmAuthVerificationMutationResult = Apollo.MutationResult<
  Types.ConfirmAuthVerificationMutation
>;
export type ConfirmAuthVerificationMutationOptions = Apollo.BaseMutationOptions<
  Types.ConfirmAuthVerificationMutation,
  Types.ConfirmAuthVerificationMutationVariables
>;
export const AutoDebitRegistrationDocument = gql`
  query AutoDebitRegistration {
    autoDebitRegistration {
      ...autoDebitRegistration
    }
  }
  ${autoDebitRegistrationFragmentDoc}
`;

/**
 * __useAutoDebitRegistrationQuery__
 *
 * To run a query within a React component, call `useAutoDebitRegistrationQuery` and pass it any options that fit your needs.
 * When your component renders, `useAutoDebitRegistrationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAutoDebitRegistrationQuery({
 *   variables: {
 *   },
 * });
 */
export function useAutoDebitRegistrationQuery(
  baseOptions?: Apollo.QueryHookOptions<
    Types.AutoDebitRegistrationQuery,
    Types.AutoDebitRegistrationQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    Types.AutoDebitRegistrationQuery,
    Types.AutoDebitRegistrationQueryVariables
  >(AutoDebitRegistrationDocument, options);
}
export function useAutoDebitRegistrationLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    Types.AutoDebitRegistrationQuery,
    Types.AutoDebitRegistrationQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    Types.AutoDebitRegistrationQuery,
    Types.AutoDebitRegistrationQueryVariables
  >(AutoDebitRegistrationDocument, options);
}
export type AutoDebitRegistrationQueryHookResult = ReturnType<
  typeof useAutoDebitRegistrationQuery
>;
export type AutoDebitRegistrationLazyQueryHookResult = ReturnType<
  typeof useAutoDebitRegistrationLazyQuery
>;
export type AutoDebitRegistrationQueryResult = Apollo.QueryResult<
  Types.AutoDebitRegistrationQuery,
  Types.AutoDebitRegistrationQueryVariables
>;
export const SuspendAutoDebitRegistrationDocument = gql`
  mutation SuspendAutoDebitRegistration($id: String!) {
    suspendAutoDebitRegistration(id: $id) {
      ...autoDebitRegistration
    }
  }
  ${autoDebitRegistrationFragmentDoc}
`;
export type SuspendAutoDebitRegistrationMutationFn = Apollo.MutationFunction<
  Types.SuspendAutoDebitRegistrationMutation,
  Types.SuspendAutoDebitRegistrationMutationVariables
>;

/**
 * __useSuspendAutoDebitRegistrationMutation__
 *
 * To run a mutation, you first call `useSuspendAutoDebitRegistrationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSuspendAutoDebitRegistrationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [suspendAutoDebitRegistrationMutation, { data, loading, error }] = useSuspendAutoDebitRegistrationMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useSuspendAutoDebitRegistrationMutation(
  baseOptions?: Apollo.MutationHookOptions<
    Types.SuspendAutoDebitRegistrationMutation,
    Types.SuspendAutoDebitRegistrationMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    Types.SuspendAutoDebitRegistrationMutation,
    Types.SuspendAutoDebitRegistrationMutationVariables
  >(SuspendAutoDebitRegistrationDocument, options);
}
export type SuspendAutoDebitRegistrationMutationHookResult = ReturnType<
  typeof useSuspendAutoDebitRegistrationMutation
>;
export type SuspendAutoDebitRegistrationMutationResult = Apollo.MutationResult<
  Types.SuspendAutoDebitRegistrationMutation
>;
export type SuspendAutoDebitRegistrationMutationOptions = Apollo.BaseMutationOptions<
  Types.SuspendAutoDebitRegistrationMutation,
  Types.SuspendAutoDebitRegistrationMutationVariables
>;
export const ResumeAutoDebitRegistrationDocument = gql`
  mutation ResumeAutoDebitRegistration($id: String!) {
    resumeAutoDebitRegistration(id: $id) {
      ...autoDebitRegistration
    }
  }
  ${autoDebitRegistrationFragmentDoc}
`;
export type ResumeAutoDebitRegistrationMutationFn = Apollo.MutationFunction<
  Types.ResumeAutoDebitRegistrationMutation,
  Types.ResumeAutoDebitRegistrationMutationVariables
>;

/**
 * __useResumeAutoDebitRegistrationMutation__
 *
 * To run a mutation, you first call `useResumeAutoDebitRegistrationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResumeAutoDebitRegistrationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resumeAutoDebitRegistrationMutation, { data, loading, error }] = useResumeAutoDebitRegistrationMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useResumeAutoDebitRegistrationMutation(
  baseOptions?: Apollo.MutationHookOptions<
    Types.ResumeAutoDebitRegistrationMutation,
    Types.ResumeAutoDebitRegistrationMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    Types.ResumeAutoDebitRegistrationMutation,
    Types.ResumeAutoDebitRegistrationMutationVariables
  >(ResumeAutoDebitRegistrationDocument, options);
}
export type ResumeAutoDebitRegistrationMutationHookResult = ReturnType<
  typeof useResumeAutoDebitRegistrationMutation
>;
export type ResumeAutoDebitRegistrationMutationResult = Apollo.MutationResult<
  Types.ResumeAutoDebitRegistrationMutation
>;
export type ResumeAutoDebitRegistrationMutationOptions = Apollo.BaseMutationOptions<
  Types.ResumeAutoDebitRegistrationMutation,
  Types.ResumeAutoDebitRegistrationMutationVariables
>;
export const DeleteAutoDebitRegistrationDocument = gql`
  mutation DeleteAutoDebitRegistration($id: String!) {
    deleteAutoDebitRegistration(id: $id) {
      ...autoDebitRegistration
    }
  }
  ${autoDebitRegistrationFragmentDoc}
`;
export type DeleteAutoDebitRegistrationMutationFn = Apollo.MutationFunction<
  Types.DeleteAutoDebitRegistrationMutation,
  Types.DeleteAutoDebitRegistrationMutationVariables
>;

/**
 * __useDeleteAutoDebitRegistrationMutation__
 *
 * To run a mutation, you first call `useDeleteAutoDebitRegistrationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteAutoDebitRegistrationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteAutoDebitRegistrationMutation, { data, loading, error }] = useDeleteAutoDebitRegistrationMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteAutoDebitRegistrationMutation(
  baseOptions?: Apollo.MutationHookOptions<
    Types.DeleteAutoDebitRegistrationMutation,
    Types.DeleteAutoDebitRegistrationMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    Types.DeleteAutoDebitRegistrationMutation,
    Types.DeleteAutoDebitRegistrationMutationVariables
  >(DeleteAutoDebitRegistrationDocument, options);
}
export type DeleteAutoDebitRegistrationMutationHookResult = ReturnType<
  typeof useDeleteAutoDebitRegistrationMutation
>;
export type DeleteAutoDebitRegistrationMutationResult = Apollo.MutationResult<
  Types.DeleteAutoDebitRegistrationMutation
>;
export type DeleteAutoDebitRegistrationMutationOptions = Apollo.BaseMutationOptions<
  Types.DeleteAutoDebitRegistrationMutation,
  Types.DeleteAutoDebitRegistrationMutationVariables
>;
export const CreateAutoDebitRegistrationDocument = gql`
  mutation CreateAutoDebitRegistration(
    $dateOfBirth: String!
    $firstName: String
    $lastName: String
  ) {
    createAutoDebitRegistration(
      dateOfBirth: $dateOfBirth
      firstName: $firstName
      lastName: $lastName
    ) {
      ...autoDebitRegistration
    }
  }
  ${autoDebitRegistrationFragmentDoc}
`;
export type CreateAutoDebitRegistrationMutationFn = Apollo.MutationFunction<
  Types.CreateAutoDebitRegistrationMutation,
  Types.CreateAutoDebitRegistrationMutationVariables
>;

/**
 * __useCreateAutoDebitRegistrationMutation__
 *
 * To run a mutation, you first call `useCreateAutoDebitRegistrationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAutoDebitRegistrationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAutoDebitRegistrationMutation, { data, loading, error }] = useCreateAutoDebitRegistrationMutation({
 *   variables: {
 *      dateOfBirth: // value for 'dateOfBirth'
 *      firstName: // value for 'firstName'
 *      lastName: // value for 'lastName'
 *   },
 * });
 */
export function useCreateAutoDebitRegistrationMutation(
  baseOptions?: Apollo.MutationHookOptions<
    Types.CreateAutoDebitRegistrationMutation,
    Types.CreateAutoDebitRegistrationMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    Types.CreateAutoDebitRegistrationMutation,
    Types.CreateAutoDebitRegistrationMutationVariables
  >(CreateAutoDebitRegistrationDocument, options);
}
export type CreateAutoDebitRegistrationMutationHookResult = ReturnType<
  typeof useCreateAutoDebitRegistrationMutation
>;
export type CreateAutoDebitRegistrationMutationResult = Apollo.MutationResult<
  Types.CreateAutoDebitRegistrationMutation
>;
export type CreateAutoDebitRegistrationMutationOptions = Apollo.BaseMutationOptions<
  Types.CreateAutoDebitRegistrationMutation,
  Types.CreateAutoDebitRegistrationMutationVariables
>;
export const BillStatementsDocument = gql`
  query BillStatements($status: BillStatementStatus) {
    billStatements(status: $status) {
      ...billStatement
    }
  }
  ${billStatementFragmentDoc}
`;

/**
 * __useBillStatementsQuery__
 *
 * To run a query within a React component, call `useBillStatementsQuery` and pass it any options that fit your needs.
 * When your component renders, `useBillStatementsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBillStatementsQuery({
 *   variables: {
 *      status: // value for 'status'
 *   },
 * });
 */
export function useBillStatementsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    Types.BillStatementsQuery,
    Types.BillStatementsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    Types.BillStatementsQuery,
    Types.BillStatementsQueryVariables
  >(BillStatementsDocument, options);
}
export function useBillStatementsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    Types.BillStatementsQuery,
    Types.BillStatementsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    Types.BillStatementsQuery,
    Types.BillStatementsQueryVariables
  >(BillStatementsDocument, options);
}
export type BillStatementsQueryHookResult = ReturnType<
  typeof useBillStatementsQuery
>;
export type BillStatementsLazyQueryHookResult = ReturnType<
  typeof useBillStatementsLazyQuery
>;
export type BillStatementsQueryResult = Apollo.QueryResult<
  Types.BillStatementsQuery,
  Types.BillStatementsQueryVariables
>;
export const MonthlyChargesBreakdownByBillIdDocument = gql`
  query MonthlyChargesBreakdownByBillId($billStatementId: String!) {
    monthlyChargesBreakdownByBillId(billStatementId: $billStatementId) {
      charges {
        ...chargeDataOfBillStatement
        installmentPlanOptions {
          available {
            ...availableInstallmentPlanData
          }
          unavailable {
            kind
            reason {
              threshold
              code
              details {
                kind
                installments {
                  id
                  amount
                  dueDate
                  dueNext
                }
              }
            }
          }
        }
      }
    }
  }
  ${chargeDataOfBillStatementFragmentDoc}
  ${availableInstallmentPlanDataFragmentDoc}
`;

/**
 * __useMonthlyChargesBreakdownByBillIdQuery__
 *
 * To run a query within a React component, call `useMonthlyChargesBreakdownByBillIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useMonthlyChargesBreakdownByBillIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMonthlyChargesBreakdownByBillIdQuery({
 *   variables: {
 *      billStatementId: // value for 'billStatementId'
 *   },
 * });
 */
export function useMonthlyChargesBreakdownByBillIdQuery(
  baseOptions: Apollo.QueryHookOptions<
    Types.MonthlyChargesBreakdownByBillIdQuery,
    Types.MonthlyChargesBreakdownByBillIdQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    Types.MonthlyChargesBreakdownByBillIdQuery,
    Types.MonthlyChargesBreakdownByBillIdQueryVariables
  >(MonthlyChargesBreakdownByBillIdDocument, options);
}
export function useMonthlyChargesBreakdownByBillIdLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    Types.MonthlyChargesBreakdownByBillIdQuery,
    Types.MonthlyChargesBreakdownByBillIdQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    Types.MonthlyChargesBreakdownByBillIdQuery,
    Types.MonthlyChargesBreakdownByBillIdQueryVariables
  >(MonthlyChargesBreakdownByBillIdDocument, options);
}
export type MonthlyChargesBreakdownByBillIdQueryHookResult = ReturnType<
  typeof useMonthlyChargesBreakdownByBillIdQuery
>;
export type MonthlyChargesBreakdownByBillIdLazyQueryHookResult = ReturnType<
  typeof useMonthlyChargesBreakdownByBillIdLazyQuery
>;
export type MonthlyChargesBreakdownByBillIdQueryResult = Apollo.QueryResult<
  Types.MonthlyChargesBreakdownByBillIdQuery,
  Types.MonthlyChargesBreakdownByBillIdQueryVariables
>;
export const CancelTransactionDocument = gql`
  mutation CancelTransaction($id: String!) {
    cancelTransaction(id: $id) {
      status
    }
  }
`;
export type CancelTransactionMutationFn = Apollo.MutationFunction<
  Types.CancelTransactionMutation,
  Types.CancelTransactionMutationVariables
>;

/**
 * __useCancelTransactionMutation__
 *
 * To run a mutation, you first call `useCancelTransactionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCancelTransactionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cancelTransactionMutation, { data, loading, error }] = useCancelTransactionMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCancelTransactionMutation(
  baseOptions?: Apollo.MutationHookOptions<
    Types.CancelTransactionMutation,
    Types.CancelTransactionMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    Types.CancelTransactionMutation,
    Types.CancelTransactionMutationVariables
  >(CancelTransactionDocument, options);
}
export type CancelTransactionMutationHookResult = ReturnType<
  typeof useCancelTransactionMutation
>;
export type CancelTransactionMutationResult = Apollo.MutationResult<
  Types.CancelTransactionMutation
>;
export type CancelTransactionMutationOptions = Apollo.BaseMutationOptions<
  Types.CancelTransactionMutation,
  Types.CancelTransactionMutationVariables
>;
export const CloseAccountDocument = gql`
  mutation CloseAccount($reason: String) {
    closeAccount(reason: $reason)
  }
`;
export type CloseAccountMutationFn = Apollo.MutationFunction<
  Types.CloseAccountMutation,
  Types.CloseAccountMutationVariables
>;

/**
 * __useCloseAccountMutation__
 *
 * To run a mutation, you first call `useCloseAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCloseAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [closeAccountMutation, { data, loading, error }] = useCloseAccountMutation({
 *   variables: {
 *      reason: // value for 'reason'
 *   },
 * });
 */
export function useCloseAccountMutation(
  baseOptions?: Apollo.MutationHookOptions<
    Types.CloseAccountMutation,
    Types.CloseAccountMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    Types.CloseAccountMutation,
    Types.CloseAccountMutationVariables
  >(CloseAccountDocument, options);
}
export type CloseAccountMutationHookResult = ReturnType<
  typeof useCloseAccountMutation
>;
export type CloseAccountMutationResult = Apollo.MutationResult<
  Types.CloseAccountMutation
>;
export type CloseAccountMutationOptions = Apollo.BaseMutationOptions<
  Types.CloseAccountMutation,
  Types.CloseAccountMutationVariables
>;
export const ConfirmResetEmailDocument = gql`
  mutation ConfirmResetEmail($otp: String!) {
    confirmResetEmail(otp: $otp)
  }
`;
export type ConfirmResetEmailMutationFn = Apollo.MutationFunction<
  Types.ConfirmResetEmailMutation,
  Types.ConfirmResetEmailMutationVariables
>;

/**
 * __useConfirmResetEmailMutation__
 *
 * To run a mutation, you first call `useConfirmResetEmailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useConfirmResetEmailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [confirmResetEmailMutation, { data, loading, error }] = useConfirmResetEmailMutation({
 *   variables: {
 *      otp: // value for 'otp'
 *   },
 * });
 */
export function useConfirmResetEmailMutation(
  baseOptions?: Apollo.MutationHookOptions<
    Types.ConfirmResetEmailMutation,
    Types.ConfirmResetEmailMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    Types.ConfirmResetEmailMutation,
    Types.ConfirmResetEmailMutationVariables
  >(ConfirmResetEmailDocument, options);
}
export type ConfirmResetEmailMutationHookResult = ReturnType<
  typeof useConfirmResetEmailMutation
>;
export type ConfirmResetEmailMutationResult = Apollo.MutationResult<
  Types.ConfirmResetEmailMutation
>;
export type ConfirmResetEmailMutationOptions = Apollo.BaseMutationOptions<
  Types.ConfirmResetEmailMutation,
  Types.ConfirmResetEmailMutationVariables
>;
export const ConfirmResetPhoneNumberDocument = gql`
  mutation ConfirmResetPhoneNumber(
    $otp: String!
    $pinCodeDispatchMethod: PinCodeDispatchMethod
  ) {
    confirmResetPhoneNumber(
      otp: $otp
      pinCodeDispatchMethod: $pinCodeDispatchMethod
    )
  }
`;
export type ConfirmResetPhoneNumberMutationFn = Apollo.MutationFunction<
  Types.ConfirmResetPhoneNumberMutation,
  Types.ConfirmResetPhoneNumberMutationVariables
>;

/**
 * __useConfirmResetPhoneNumberMutation__
 *
 * To run a mutation, you first call `useConfirmResetPhoneNumberMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useConfirmResetPhoneNumberMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [confirmResetPhoneNumberMutation, { data, loading, error }] = useConfirmResetPhoneNumberMutation({
 *   variables: {
 *      otp: // value for 'otp'
 *      pinCodeDispatchMethod: // value for 'pinCodeDispatchMethod'
 *   },
 * });
 */
export function useConfirmResetPhoneNumberMutation(
  baseOptions?: Apollo.MutationHookOptions<
    Types.ConfirmResetPhoneNumberMutation,
    Types.ConfirmResetPhoneNumberMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    Types.ConfirmResetPhoneNumberMutation,
    Types.ConfirmResetPhoneNumberMutationVariables
  >(ConfirmResetPhoneNumberDocument, options);
}
export type ConfirmResetPhoneNumberMutationHookResult = ReturnType<
  typeof useConfirmResetPhoneNumberMutation
>;
export type ConfirmResetPhoneNumberMutationResult = Apollo.MutationResult<
  Types.ConfirmResetPhoneNumberMutation
>;
export type ConfirmResetPhoneNumberMutationOptions = Apollo.BaseMutationOptions<
  Types.ConfirmResetPhoneNumberMutation,
  Types.ConfirmResetPhoneNumberMutationVariables
>;
export const ConsumerBalanceSummaryDocument = gql`
  query ConsumerBalanceSummary {
    consumerBalanceSummary {
      ...consumerBalanceSummary
    }
  }
  ${consumerBalanceSummaryFragmentDoc}
`;

/**
 * __useConsumerBalanceSummaryQuery__
 *
 * To run a query within a React component, call `useConsumerBalanceSummaryQuery` and pass it any options that fit your needs.
 * When your component renders, `useConsumerBalanceSummaryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useConsumerBalanceSummaryQuery({
 *   variables: {
 *   },
 * });
 */
export function useConsumerBalanceSummaryQuery(
  baseOptions?: Apollo.QueryHookOptions<
    Types.ConsumerBalanceSummaryQuery,
    Types.ConsumerBalanceSummaryQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    Types.ConsumerBalanceSummaryQuery,
    Types.ConsumerBalanceSummaryQueryVariables
  >(ConsumerBalanceSummaryDocument, options);
}
export function useConsumerBalanceSummaryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    Types.ConsumerBalanceSummaryQuery,
    Types.ConsumerBalanceSummaryQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    Types.ConsumerBalanceSummaryQuery,
    Types.ConsumerBalanceSummaryQueryVariables
  >(ConsumerBalanceSummaryDocument, options);
}
export type ConsumerBalanceSummaryQueryHookResult = ReturnType<
  typeof useConsumerBalanceSummaryQuery
>;
export type ConsumerBalanceSummaryLazyQueryHookResult = ReturnType<
  typeof useConsumerBalanceSummaryLazyQuery
>;
export type ConsumerBalanceSummaryQueryResult = Apollo.QueryResult<
  Types.ConsumerBalanceSummaryQuery,
  Types.ConsumerBalanceSummaryQueryVariables
>;
export const ConsumerDocument = gql`
  query Consumer($masked: Boolean) {
    consumer(masked: $masked) {
      email
      phone
      name1
      name2
      dateOfBirth
      address {
        line1
        line2
        city
        state
        zip
      }
      externalConsumerIds {
        notifications
        tracking
      }
      status
      consumerInfo {
        cardEligibilityInfo {
          hadVirtualCard
          isEligibleForVirtualCard
          hasAppliedForVirtualCard
        }
        consumerFlags
      }
    }
  }
`;

/**
 * __useConsumerQuery__
 *
 * To run a query within a React component, call `useConsumerQuery` and pass it any options that fit your needs.
 * When your component renders, `useConsumerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useConsumerQuery({
 *   variables: {
 *      masked: // value for 'masked'
 *   },
 * });
 */
export function useConsumerQuery(
  baseOptions?: Apollo.QueryHookOptions<
    Types.ConsumerQuery,
    Types.ConsumerQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<Types.ConsumerQuery, Types.ConsumerQueryVariables>(
    ConsumerDocument,
    options
  );
}
export function useConsumerLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    Types.ConsumerQuery,
    Types.ConsumerQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<Types.ConsumerQuery, Types.ConsumerQueryVariables>(
    ConsumerDocument,
    options
  );
}
export type ConsumerQueryHookResult = ReturnType<typeof useConsumerQuery>;
export type ConsumerLazyQueryHookResult = ReturnType<
  typeof useConsumerLazyQuery
>;
export type ConsumerQueryResult = Apollo.QueryResult<
  Types.ConsumerQuery,
  Types.ConsumerQueryVariables
>;
export const CreateInstallmentPlanDocument = gql`
  mutation CreateInstallmentPlan(
    $chargeId: String!
    $kind: InstallmentPlanKind!
  ) {
    createInstallmentPlan(chargeId: $chargeId, kind: $kind) {
      ...installmentPlanData
    }
  }
  ${installmentPlanDataFragmentDoc}
`;
export type CreateInstallmentPlanMutationFn = Apollo.MutationFunction<
  Types.CreateInstallmentPlanMutation,
  Types.CreateInstallmentPlanMutationVariables
>;

/**
 * __useCreateInstallmentPlanMutation__
 *
 * To run a mutation, you first call `useCreateInstallmentPlanMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateInstallmentPlanMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createInstallmentPlanMutation, { data, loading, error }] = useCreateInstallmentPlanMutation({
 *   variables: {
 *      chargeId: // value for 'chargeId'
 *      kind: // value for 'kind'
 *   },
 * });
 */
export function useCreateInstallmentPlanMutation(
  baseOptions?: Apollo.MutationHookOptions<
    Types.CreateInstallmentPlanMutation,
    Types.CreateInstallmentPlanMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    Types.CreateInstallmentPlanMutation,
    Types.CreateInstallmentPlanMutationVariables
  >(CreateInstallmentPlanDocument, options);
}
export type CreateInstallmentPlanMutationHookResult = ReturnType<
  typeof useCreateInstallmentPlanMutation
>;
export type CreateInstallmentPlanMutationResult = Apollo.MutationResult<
  Types.CreateInstallmentPlanMutation
>;
export type CreateInstallmentPlanMutationOptions = Apollo.BaseMutationOptions<
  Types.CreateInstallmentPlanMutation,
  Types.CreateInstallmentPlanMutationVariables
>;
export const CreateKYCApplicationDocument = gql`
  mutation CreateKYCApplication($data: CreateKYCApplicationRequest!) {
    createKYCApplication(data: $data) {
      url
    }
  }
`;
export type CreateKYCApplicationMutationFn = Apollo.MutationFunction<
  Types.CreateKYCApplicationMutation,
  Types.CreateKYCApplicationMutationVariables
>;

/**
 * __useCreateKYCApplicationMutation__
 *
 * To run a mutation, you first call `useCreateKYCApplicationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateKYCApplicationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createKycApplicationMutation, { data, loading, error }] = useCreateKYCApplicationMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateKYCApplicationMutation(
  baseOptions?: Apollo.MutationHookOptions<
    Types.CreateKYCApplicationMutation,
    Types.CreateKYCApplicationMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    Types.CreateKYCApplicationMutation,
    Types.CreateKYCApplicationMutationVariables
  >(CreateKYCApplicationDocument, options);
}
export type CreateKYCApplicationMutationHookResult = ReturnType<
  typeof useCreateKYCApplicationMutation
>;
export type CreateKYCApplicationMutationResult = Apollo.MutationResult<
  Types.CreateKYCApplicationMutation
>;
export type CreateKYCApplicationMutationOptions = Apollo.BaseMutationOptions<
  Types.CreateKYCApplicationMutation,
  Types.CreateKYCApplicationMutationVariables
>;
export const CreateKycWebApplicationDocument = gql`
  mutation CreateKycWebApplication($idDocumentType: KycIdDocumentType) {
    createKYCWebApplication(idDocumentType: $idDocumentType) {
      applicationUrl
      applicantId
    }
  }
`;
export type CreateKycWebApplicationMutationFn = Apollo.MutationFunction<
  Types.CreateKycWebApplicationMutation,
  Types.CreateKycWebApplicationMutationVariables
>;

/**
 * __useCreateKycWebApplicationMutation__
 *
 * To run a mutation, you first call `useCreateKycWebApplicationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateKycWebApplicationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createKycWebApplicationMutation, { data, loading, error }] = useCreateKycWebApplicationMutation({
 *   variables: {
 *      idDocumentType: // value for 'idDocumentType'
 *   },
 * });
 */
export function useCreateKycWebApplicationMutation(
  baseOptions?: Apollo.MutationHookOptions<
    Types.CreateKycWebApplicationMutation,
    Types.CreateKycWebApplicationMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    Types.CreateKycWebApplicationMutation,
    Types.CreateKycWebApplicationMutationVariables
  >(CreateKycWebApplicationDocument, options);
}
export type CreateKycWebApplicationMutationHookResult = ReturnType<
  typeof useCreateKycWebApplicationMutation
>;
export type CreateKycWebApplicationMutationResult = Apollo.MutationResult<
  Types.CreateKycWebApplicationMutation
>;
export type CreateKycWebApplicationMutationOptions = Apollo.BaseMutationOptions<
  Types.CreateKycWebApplicationMutation,
  Types.CreateKycWebApplicationMutationVariables
>;
export const CreateLiquidTokenDocument = gql`
  mutation CreateLiquidToken {
    liquidApplication: createLiquidSdkApplication {
      token
      applicantId
    }
  }
`;
export type CreateLiquidTokenMutationFn = Apollo.MutationFunction<
  Types.CreateLiquidTokenMutation,
  Types.CreateLiquidTokenMutationVariables
>;

/**
 * __useCreateLiquidTokenMutation__
 *
 * To run a mutation, you first call `useCreateLiquidTokenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateLiquidTokenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createLiquidTokenMutation, { data, loading, error }] = useCreateLiquidTokenMutation({
 *   variables: {
 *   },
 * });
 */
export function useCreateLiquidTokenMutation(
  baseOptions?: Apollo.MutationHookOptions<
    Types.CreateLiquidTokenMutation,
    Types.CreateLiquidTokenMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    Types.CreateLiquidTokenMutation,
    Types.CreateLiquidTokenMutationVariables
  >(CreateLiquidTokenDocument, options);
}
export type CreateLiquidTokenMutationHookResult = ReturnType<
  typeof useCreateLiquidTokenMutation
>;
export type CreateLiquidTokenMutationResult = Apollo.MutationResult<
  Types.CreateLiquidTokenMutation
>;
export type CreateLiquidTokenMutationOptions = Apollo.BaseMutationOptions<
  Types.CreateLiquidTokenMutation,
  Types.CreateLiquidTokenMutationVariables
>;
export const CreditLimitUpgradeStatusDocument = gql`
  query CreditLimitUpgradeStatus {
    CreditLimitUpgradeStatus {
      status
    }
  }
`;

/**
 * __useCreditLimitUpgradeStatusQuery__
 *
 * To run a query within a React component, call `useCreditLimitUpgradeStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useCreditLimitUpgradeStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCreditLimitUpgradeStatusQuery({
 *   variables: {
 *   },
 * });
 */
export function useCreditLimitUpgradeStatusQuery(
  baseOptions?: Apollo.QueryHookOptions<
    Types.CreditLimitUpgradeStatusQuery,
    Types.CreditLimitUpgradeStatusQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    Types.CreditLimitUpgradeStatusQuery,
    Types.CreditLimitUpgradeStatusQueryVariables
  >(CreditLimitUpgradeStatusDocument, options);
}
export function useCreditLimitUpgradeStatusLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    Types.CreditLimitUpgradeStatusQuery,
    Types.CreditLimitUpgradeStatusQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    Types.CreditLimitUpgradeStatusQuery,
    Types.CreditLimitUpgradeStatusQueryVariables
  >(CreditLimitUpgradeStatusDocument, options);
}
export type CreditLimitUpgradeStatusQueryHookResult = ReturnType<
  typeof useCreditLimitUpgradeStatusQuery
>;
export type CreditLimitUpgradeStatusLazyQueryHookResult = ReturnType<
  typeof useCreditLimitUpgradeStatusLazyQuery
>;
export type CreditLimitUpgradeStatusQueryResult = Apollo.QueryResult<
  Types.CreditLimitUpgradeStatusQuery,
  Types.CreditLimitUpgradeStatusQueryVariables
>;
export const CreditLimitDocument = gql`
  query CreditLimit {
    creditLimit {
      creditLimit
      outstandingDebt
      remainingLimit
      kind
    }
  }
`;

/**
 * __useCreditLimitQuery__
 *
 * To run a query within a React component, call `useCreditLimitQuery` and pass it any options that fit your needs.
 * When your component renders, `useCreditLimitQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCreditLimitQuery({
 *   variables: {
 *   },
 * });
 */
export function useCreditLimitQuery(
  baseOptions?: Apollo.QueryHookOptions<
    Types.CreditLimitQuery,
    Types.CreditLimitQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    Types.CreditLimitQuery,
    Types.CreditLimitQueryVariables
  >(CreditLimitDocument, options);
}
export function useCreditLimitLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    Types.CreditLimitQuery,
    Types.CreditLimitQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    Types.CreditLimitQuery,
    Types.CreditLimitQueryVariables
  >(CreditLimitDocument, options);
}
export type CreditLimitQueryHookResult = ReturnType<typeof useCreditLimitQuery>;
export type CreditLimitLazyQueryHookResult = ReturnType<
  typeof useCreditLimitLazyQuery
>;
export type CreditLimitQueryResult = Apollo.QueryResult<
  Types.CreditLimitQuery,
  Types.CreditLimitQueryVariables
>;
export const CreditLimitsDocument = gql`
  query CreditLimits {
    creditLimits {
      creditLimit
      outstandingDebt
      remainingLimit
      kind
    }
  }
`;

/**
 * __useCreditLimitsQuery__
 *
 * To run a query within a React component, call `useCreditLimitsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCreditLimitsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCreditLimitsQuery({
 *   variables: {
 *   },
 * });
 */
export function useCreditLimitsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    Types.CreditLimitsQuery,
    Types.CreditLimitsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    Types.CreditLimitsQuery,
    Types.CreditLimitsQueryVariables
  >(CreditLimitsDocument, options);
}
export function useCreditLimitsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    Types.CreditLimitsQuery,
    Types.CreditLimitsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    Types.CreditLimitsQuery,
    Types.CreditLimitsQueryVariables
  >(CreditLimitsDocument, options);
}
export type CreditLimitsQueryHookResult = ReturnType<
  typeof useCreditLimitsQuery
>;
export type CreditLimitsLazyQueryHookResult = ReturnType<
  typeof useCreditLimitsLazyQuery
>;
export type CreditLimitsQueryResult = Apollo.QueryResult<
  Types.CreditLimitsQuery,
  Types.CreditLimitsQueryVariables
>;
export const createPaynowBarcodeV3Document = gql`
  mutation createPaynowBarcodeV3(
    $payableAmount: Float!
    $combiniFee: Float!
    $referenceIds: ReferenceIds!
    $deviceInfo: DeviceInfo!
    $cvsStoreId: String!
  ) {
    createPaynowBarcodeV3(
      payableAmount: $payableAmount
      combiniFee: $combiniFee
      referenceIds: $referenceIds
      deviceInfo: $deviceInfo
      cvsStoreId: $cvsStoreId
    ) {
      amount
      settlementFeeAmount
      currency
      imgH
      imgW
      imgFormat
      barcodeData
    }
  }
`;
export type createPaynowBarcodeV3MutationFn = Apollo.MutationFunction<
  Types.createPaynowBarcodeV3Mutation,
  Types.createPaynowBarcodeV3MutationVariables
>;

/**
 * __usecreatePaynowBarcodeV3Mutation__
 *
 * To run a mutation, you first call `usecreatePaynowBarcodeV3Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usecreatePaynowBarcodeV3Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPaynowBarcodeV3Mutation, { data, loading, error }] = usecreatePaynowBarcodeV3Mutation({
 *   variables: {
 *      payableAmount: // value for 'payableAmount'
 *      combiniFee: // value for 'combiniFee'
 *      referenceIds: // value for 'referenceIds'
 *      deviceInfo: // value for 'deviceInfo'
 *      cvsStoreId: // value for 'cvsStoreId'
 *   },
 * });
 */
export function usecreatePaynowBarcodeV3Mutation(
  baseOptions?: Apollo.MutationHookOptions<
    Types.createPaynowBarcodeV3Mutation,
    Types.createPaynowBarcodeV3MutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    Types.createPaynowBarcodeV3Mutation,
    Types.createPaynowBarcodeV3MutationVariables
  >(createPaynowBarcodeV3Document, options);
}
export type createPaynowBarcodeV3MutationHookResult = ReturnType<
  typeof usecreatePaynowBarcodeV3Mutation
>;
export type createPaynowBarcodeV3MutationResult = Apollo.MutationResult<
  Types.createPaynowBarcodeV3Mutation
>;
export type createPaynowBarcodeV3MutationOptions = Apollo.BaseMutationOptions<
  Types.createPaynowBarcodeV3Mutation,
  Types.createPaynowBarcodeV3MutationVariables
>;
export const createPaynowNumericCodeV3Document = gql`
  mutation createPaynowNumericCodeV3(
    $payableAmount: Float!
    $combiniFee: Float!
    $referenceIds: ReferenceIds!
    $cvsStoreId: String!
  ) {
    createPaynowNumericCodeV3(
      payableAmount: $payableAmount
      combiniFee: $combiniFee
      referenceIds: $referenceIds
      cvsStoreId: $cvsStoreId
    ) {
      amount
      settlementFeeAmount
      currency
      codes {
        consumerCode
        merchantCode
        store
      }
    }
  }
`;
export type createPaynowNumericCodeV3MutationFn = Apollo.MutationFunction<
  Types.createPaynowNumericCodeV3Mutation,
  Types.createPaynowNumericCodeV3MutationVariables
>;

/**
 * __usecreatePaynowNumericCodeV3Mutation__
 *
 * To run a mutation, you first call `usecreatePaynowNumericCodeV3Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usecreatePaynowNumericCodeV3Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPaynowNumericCodeV3Mutation, { data, loading, error }] = usecreatePaynowNumericCodeV3Mutation({
 *   variables: {
 *      payableAmount: // value for 'payableAmount'
 *      combiniFee: // value for 'combiniFee'
 *      referenceIds: // value for 'referenceIds'
 *      cvsStoreId: // value for 'cvsStoreId'
 *   },
 * });
 */
export function usecreatePaynowNumericCodeV3Mutation(
  baseOptions?: Apollo.MutationHookOptions<
    Types.createPaynowNumericCodeV3Mutation,
    Types.createPaynowNumericCodeV3MutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    Types.createPaynowNumericCodeV3Mutation,
    Types.createPaynowNumericCodeV3MutationVariables
  >(createPaynowNumericCodeV3Document, options);
}
export type createPaynowNumericCodeV3MutationHookResult = ReturnType<
  typeof usecreatePaynowNumericCodeV3Mutation
>;
export type createPaynowNumericCodeV3MutationResult = Apollo.MutationResult<
  Types.createPaynowNumericCodeV3Mutation
>;
export type createPaynowNumericCodeV3MutationOptions = Apollo.BaseMutationOptions<
  Types.createPaynowNumericCodeV3Mutation,
  Types.createPaynowNumericCodeV3MutationVariables
>;
export const createSinglebillBarcodeV3Document = gql`
  mutation createSinglebillBarcodeV3(
    $billId: String!
    $deviceInfo: DeviceInfo!
    $cvsStoreId: String!
  ) {
    createSinglebillBarcodeV3(
      billId: $billId
      deviceInfo: $deviceInfo
      cvsStoreId: $cvsStoreId
    ) {
      amount
      settlementFeeAmount
      currency
      imgH
      imgW
      imgFormat
      barcodeData
    }
  }
`;
export type createSinglebillBarcodeV3MutationFn = Apollo.MutationFunction<
  Types.createSinglebillBarcodeV3Mutation,
  Types.createSinglebillBarcodeV3MutationVariables
>;

/**
 * __usecreateSinglebillBarcodeV3Mutation__
 *
 * To run a mutation, you first call `usecreateSinglebillBarcodeV3Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usecreateSinglebillBarcodeV3Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createSinglebillBarcodeV3Mutation, { data, loading, error }] = usecreateSinglebillBarcodeV3Mutation({
 *   variables: {
 *      billId: // value for 'billId'
 *      deviceInfo: // value for 'deviceInfo'
 *      cvsStoreId: // value for 'cvsStoreId'
 *   },
 * });
 */
export function usecreateSinglebillBarcodeV3Mutation(
  baseOptions?: Apollo.MutationHookOptions<
    Types.createSinglebillBarcodeV3Mutation,
    Types.createSinglebillBarcodeV3MutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    Types.createSinglebillBarcodeV3Mutation,
    Types.createSinglebillBarcodeV3MutationVariables
  >(createSinglebillBarcodeV3Document, options);
}
export type createSinglebillBarcodeV3MutationHookResult = ReturnType<
  typeof usecreateSinglebillBarcodeV3Mutation
>;
export type createSinglebillBarcodeV3MutationResult = Apollo.MutationResult<
  Types.createSinglebillBarcodeV3Mutation
>;
export type createSinglebillBarcodeV3MutationOptions = Apollo.BaseMutationOptions<
  Types.createSinglebillBarcodeV3Mutation,
  Types.createSinglebillBarcodeV3MutationVariables
>;
export const createSinglebillNumericCodeV3Document = gql`
  mutation createSinglebillNumericCodeV3(
    $billId: String!
    $cvsStoreId: String!
  ) {
    createSinglebillNumericCodeV3(billId: $billId, cvsStoreId: $cvsStoreId) {
      amount
      settlementFeeAmount
      currency
      codes {
        consumerCode
        merchantCode
        store
      }
    }
  }
`;
export type createSinglebillNumericCodeV3MutationFn = Apollo.MutationFunction<
  Types.createSinglebillNumericCodeV3Mutation,
  Types.createSinglebillNumericCodeV3MutationVariables
>;

/**
 * __usecreateSinglebillNumericCodeV3Mutation__
 *
 * To run a mutation, you first call `usecreateSinglebillNumericCodeV3Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usecreateSinglebillNumericCodeV3Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createSinglebillNumericCodeV3Mutation, { data, loading, error }] = usecreateSinglebillNumericCodeV3Mutation({
 *   variables: {
 *      billId: // value for 'billId'
 *      cvsStoreId: // value for 'cvsStoreId'
 *   },
 * });
 */
export function usecreateSinglebillNumericCodeV3Mutation(
  baseOptions?: Apollo.MutationHookOptions<
    Types.createSinglebillNumericCodeV3Mutation,
    Types.createSinglebillNumericCodeV3MutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    Types.createSinglebillNumericCodeV3Mutation,
    Types.createSinglebillNumericCodeV3MutationVariables
  >(createSinglebillNumericCodeV3Document, options);
}
export type createSinglebillNumericCodeV3MutationHookResult = ReturnType<
  typeof usecreateSinglebillNumericCodeV3Mutation
>;
export type createSinglebillNumericCodeV3MutationResult = Apollo.MutationResult<
  Types.createSinglebillNumericCodeV3Mutation
>;
export type createSinglebillNumericCodeV3MutationOptions = Apollo.BaseMutationOptions<
  Types.createSinglebillNumericCodeV3Mutation,
  Types.createSinglebillNumericCodeV3MutationVariables
>;
export const DoResetEmailDocument = gql`
  mutation DoResetEmail($otp: String!) {
    doResetEmail(otp: $otp)
  }
`;
export type DoResetEmailMutationFn = Apollo.MutationFunction<
  Types.DoResetEmailMutation,
  Types.DoResetEmailMutationVariables
>;

/**
 * __useDoResetEmailMutation__
 *
 * To run a mutation, you first call `useDoResetEmailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDoResetEmailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [doResetEmailMutation, { data, loading, error }] = useDoResetEmailMutation({
 *   variables: {
 *      otp: // value for 'otp'
 *   },
 * });
 */
export function useDoResetEmailMutation(
  baseOptions?: Apollo.MutationHookOptions<
    Types.DoResetEmailMutation,
    Types.DoResetEmailMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    Types.DoResetEmailMutation,
    Types.DoResetEmailMutationVariables
  >(DoResetEmailDocument, options);
}
export type DoResetEmailMutationHookResult = ReturnType<
  typeof useDoResetEmailMutation
>;
export type DoResetEmailMutationResult = Apollo.MutationResult<
  Types.DoResetEmailMutation
>;
export type DoResetEmailMutationOptions = Apollo.BaseMutationOptions<
  Types.DoResetEmailMutation,
  Types.DoResetEmailMutationVariables
>;
export const DoResetPhoneNumberDocument = gql`
  mutation DoResetPhoneNumber($otp: String!) {
    doResetPhoneNumber(otp: $otp)
  }
`;
export type DoResetPhoneNumberMutationFn = Apollo.MutationFunction<
  Types.DoResetPhoneNumberMutation,
  Types.DoResetPhoneNumberMutationVariables
>;

/**
 * __useDoResetPhoneNumberMutation__
 *
 * To run a mutation, you first call `useDoResetPhoneNumberMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDoResetPhoneNumberMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [doResetPhoneNumberMutation, { data, loading, error }] = useDoResetPhoneNumberMutation({
 *   variables: {
 *      otp: // value for 'otp'
 *   },
 * });
 */
export function useDoResetPhoneNumberMutation(
  baseOptions?: Apollo.MutationHookOptions<
    Types.DoResetPhoneNumberMutation,
    Types.DoResetPhoneNumberMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    Types.DoResetPhoneNumberMutation,
    Types.DoResetPhoneNumberMutationVariables
  >(DoResetPhoneNumberDocument, options);
}
export type DoResetPhoneNumberMutationHookResult = ReturnType<
  typeof useDoResetPhoneNumberMutation
>;
export type DoResetPhoneNumberMutationResult = Apollo.MutationResult<
  Types.DoResetPhoneNumberMutation
>;
export type DoResetPhoneNumberMutationOptions = Apollo.BaseMutationOptions<
  Types.DoResetPhoneNumberMutation,
  Types.DoResetPhoneNumberMutationVariables
>;
export const FeaturesWithVariantsDocument = gql`
  query FeaturesWithVariants {
    featuresWithVariants {
      enabled {
        name
        variant
      }
    }
  }
`;

/**
 * __useFeaturesWithVariantsQuery__
 *
 * To run a query within a React component, call `useFeaturesWithVariantsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFeaturesWithVariantsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFeaturesWithVariantsQuery({
 *   variables: {
 *   },
 * });
 */
export function useFeaturesWithVariantsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    Types.FeaturesWithVariantsQuery,
    Types.FeaturesWithVariantsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    Types.FeaturesWithVariantsQuery,
    Types.FeaturesWithVariantsQueryVariables
  >(FeaturesWithVariantsDocument, options);
}
export function useFeaturesWithVariantsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    Types.FeaturesWithVariantsQuery,
    Types.FeaturesWithVariantsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    Types.FeaturesWithVariantsQuery,
    Types.FeaturesWithVariantsQueryVariables
  >(FeaturesWithVariantsDocument, options);
}
export type FeaturesWithVariantsQueryHookResult = ReturnType<
  typeof useFeaturesWithVariantsQuery
>;
export type FeaturesWithVariantsLazyQueryHookResult = ReturnType<
  typeof useFeaturesWithVariantsLazyQuery
>;
export type FeaturesWithVariantsQueryResult = Apollo.QueryResult<
  Types.FeaturesWithVariantsQuery,
  Types.FeaturesWithVariantsQueryVariables
>;
export const FeaturesDocument = gql`
  query Features {
    features {
      enabled
    }
  }
`;

/**
 * __useFeaturesQuery__
 *
 * To run a query within a React component, call `useFeaturesQuery` and pass it any options that fit your needs.
 * When your component renders, `useFeaturesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFeaturesQuery({
 *   variables: {
 *   },
 * });
 */
export function useFeaturesQuery(
  baseOptions?: Apollo.QueryHookOptions<
    Types.FeaturesQuery,
    Types.FeaturesQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<Types.FeaturesQuery, Types.FeaturesQueryVariables>(
    FeaturesDocument,
    options
  );
}
export function useFeaturesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    Types.FeaturesQuery,
    Types.FeaturesQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<Types.FeaturesQuery, Types.FeaturesQueryVariables>(
    FeaturesDocument,
    options
  );
}
export type FeaturesQueryHookResult = ReturnType<typeof useFeaturesQuery>;
export type FeaturesLazyQueryHookResult = ReturnType<
  typeof useFeaturesLazyQuery
>;
export type FeaturesQueryResult = Apollo.QueryResult<
  Types.FeaturesQuery,
  Types.FeaturesQueryVariables
>;
export const InitiateResetEmailDocument = gql`
  mutation InitiateResetEmail(
    $newEmail: String!
    $pinCodeDispatchMethod: PinCodeDispatchMethod
  ) {
    initiateResetEmail(
      newEmail: $newEmail
      pinCodeDispatchMethod: $pinCodeDispatchMethod
    )
  }
`;
export type InitiateResetEmailMutationFn = Apollo.MutationFunction<
  Types.InitiateResetEmailMutation,
  Types.InitiateResetEmailMutationVariables
>;

/**
 * __useInitiateResetEmailMutation__
 *
 * To run a mutation, you first call `useInitiateResetEmailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInitiateResetEmailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [initiateResetEmailMutation, { data, loading, error }] = useInitiateResetEmailMutation({
 *   variables: {
 *      newEmail: // value for 'newEmail'
 *      pinCodeDispatchMethod: // value for 'pinCodeDispatchMethod'
 *   },
 * });
 */
export function useInitiateResetEmailMutation(
  baseOptions?: Apollo.MutationHookOptions<
    Types.InitiateResetEmailMutation,
    Types.InitiateResetEmailMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    Types.InitiateResetEmailMutation,
    Types.InitiateResetEmailMutationVariables
  >(InitiateResetEmailDocument, options);
}
export type InitiateResetEmailMutationHookResult = ReturnType<
  typeof useInitiateResetEmailMutation
>;
export type InitiateResetEmailMutationResult = Apollo.MutationResult<
  Types.InitiateResetEmailMutation
>;
export type InitiateResetEmailMutationOptions = Apollo.BaseMutationOptions<
  Types.InitiateResetEmailMutation,
  Types.InitiateResetEmailMutationVariables
>;
export const InitiateResetPhoneNumberDocument = gql`
  mutation InitiateResetPhoneNumber($newPhoneNumber: String!) {
    initiateResetPhoneNumber(newPhoneNumber: $newPhoneNumber)
  }
`;
export type InitiateResetPhoneNumberMutationFn = Apollo.MutationFunction<
  Types.InitiateResetPhoneNumberMutation,
  Types.InitiateResetPhoneNumberMutationVariables
>;

/**
 * __useInitiateResetPhoneNumberMutation__
 *
 * To run a mutation, you first call `useInitiateResetPhoneNumberMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInitiateResetPhoneNumberMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [initiateResetPhoneNumberMutation, { data, loading, error }] = useInitiateResetPhoneNumberMutation({
 *   variables: {
 *      newPhoneNumber: // value for 'newPhoneNumber'
 *   },
 * });
 */
export function useInitiateResetPhoneNumberMutation(
  baseOptions?: Apollo.MutationHookOptions<
    Types.InitiateResetPhoneNumberMutation,
    Types.InitiateResetPhoneNumberMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    Types.InitiateResetPhoneNumberMutation,
    Types.InitiateResetPhoneNumberMutationVariables
  >(InitiateResetPhoneNumberDocument, options);
}
export type InitiateResetPhoneNumberMutationHookResult = ReturnType<
  typeof useInitiateResetPhoneNumberMutation
>;
export type InitiateResetPhoneNumberMutationResult = Apollo.MutationResult<
  Types.InitiateResetPhoneNumberMutation
>;
export type InitiateResetPhoneNumberMutationOptions = Apollo.BaseMutationOptions<
  Types.InitiateResetPhoneNumberMutation,
  Types.InitiateResetPhoneNumberMutationVariables
>;
export const InstallmentPlanDocument = gql`
  query InstallmentPlan($id: String!) {
    installmentPlan(id: $id) {
      ...installmentPlanData
    }
  }
  ${installmentPlanDataFragmentDoc}
`;

/**
 * __useInstallmentPlanQuery__
 *
 * To run a query within a React component, call `useInstallmentPlanQuery` and pass it any options that fit your needs.
 * When your component renders, `useInstallmentPlanQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInstallmentPlanQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useInstallmentPlanQuery(
  baseOptions: Apollo.QueryHookOptions<
    Types.InstallmentPlanQuery,
    Types.InstallmentPlanQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    Types.InstallmentPlanQuery,
    Types.InstallmentPlanQueryVariables
  >(InstallmentPlanDocument, options);
}
export function useInstallmentPlanLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    Types.InstallmentPlanQuery,
    Types.InstallmentPlanQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    Types.InstallmentPlanQuery,
    Types.InstallmentPlanQueryVariables
  >(InstallmentPlanDocument, options);
}
export type InstallmentPlanQueryHookResult = ReturnType<
  typeof useInstallmentPlanQuery
>;
export type InstallmentPlanLazyQueryHookResult = ReturnType<
  typeof useInstallmentPlanLazyQuery
>;
export type InstallmentPlanQueryResult = Apollo.QueryResult<
  Types.InstallmentPlanQuery,
  Types.InstallmentPlanQueryVariables
>;
export const InstallmentPlansV2Document = gql`
  query InstallmentPlansV2(
    $kinds: [InstallmentPlanKind!]
    $status: [InstallmentPlanStatus!]
    $dueDateAfter: String
    $limit: Int
  ) {
    installmentPlansV2(
      kinds: $kinds
      status: $status
      dueDateAfter: $dueDateAfter
      limit: $limit
    ) {
      ...installmentPlanData
    }
  }
  ${installmentPlanDataFragmentDoc}
`;

/**
 * __useInstallmentPlansV2Query__
 *
 * To run a query within a React component, call `useInstallmentPlansV2Query` and pass it any options that fit your needs.
 * When your component renders, `useInstallmentPlansV2Query` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInstallmentPlansV2Query({
 *   variables: {
 *      kinds: // value for 'kinds'
 *      status: // value for 'status'
 *      dueDateAfter: // value for 'dueDateAfter'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useInstallmentPlansV2Query(
  baseOptions?: Apollo.QueryHookOptions<
    Types.InstallmentPlansV2Query,
    Types.InstallmentPlansV2QueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    Types.InstallmentPlansV2Query,
    Types.InstallmentPlansV2QueryVariables
  >(InstallmentPlansV2Document, options);
}
export function useInstallmentPlansV2LazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    Types.InstallmentPlansV2Query,
    Types.InstallmentPlansV2QueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    Types.InstallmentPlansV2Query,
    Types.InstallmentPlansV2QueryVariables
  >(InstallmentPlansV2Document, options);
}
export type InstallmentPlansV2QueryHookResult = ReturnType<
  typeof useInstallmentPlansV2Query
>;
export type InstallmentPlansV2LazyQueryHookResult = ReturnType<
  typeof useInstallmentPlansV2LazyQuery
>;
export type InstallmentPlansV2QueryResult = Apollo.QueryResult<
  Types.InstallmentPlansV2Query,
  Types.InstallmentPlansV2QueryVariables
>;
export const KYCApplicationDetailsDocument = gql`
  query KYCApplicationDetails {
    KYCApplicationDetails {
      lastName
      firstName
      lastNameKana
      firstNameKana
      address {
        line1
        line2
        city
        state
        zip
      }
      profession
      purpose
      timestampUtc
    }
  }
`;

/**
 * __useKYCApplicationDetailsQuery__
 *
 * To run a query within a React component, call `useKYCApplicationDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useKYCApplicationDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useKYCApplicationDetailsQuery({
 *   variables: {
 *   },
 * });
 */
export function useKYCApplicationDetailsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    Types.KYCApplicationDetailsQuery,
    Types.KYCApplicationDetailsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    Types.KYCApplicationDetailsQuery,
    Types.KYCApplicationDetailsQueryVariables
  >(KYCApplicationDetailsDocument, options);
}
export function useKYCApplicationDetailsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    Types.KYCApplicationDetailsQuery,
    Types.KYCApplicationDetailsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    Types.KYCApplicationDetailsQuery,
    Types.KYCApplicationDetailsQueryVariables
  >(KYCApplicationDetailsDocument, options);
}
export type KYCApplicationDetailsQueryHookResult = ReturnType<
  typeof useKYCApplicationDetailsQuery
>;
export type KYCApplicationDetailsLazyQueryHookResult = ReturnType<
  typeof useKYCApplicationDetailsLazyQuery
>;
export type KYCApplicationDetailsQueryResult = Apollo.QueryResult<
  Types.KYCApplicationDetailsQuery,
  Types.KYCApplicationDetailsQueryVariables
>;
export const KYCApplicationStatusDocument = gql`
  query KYCApplicationStatus {
    KYCApplicationStatus {
      status
    }
  }
`;

/**
 * __useKYCApplicationStatusQuery__
 *
 * To run a query within a React component, call `useKYCApplicationStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useKYCApplicationStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useKYCApplicationStatusQuery({
 *   variables: {
 *   },
 * });
 */
export function useKYCApplicationStatusQuery(
  baseOptions?: Apollo.QueryHookOptions<
    Types.KYCApplicationStatusQuery,
    Types.KYCApplicationStatusQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    Types.KYCApplicationStatusQuery,
    Types.KYCApplicationStatusQueryVariables
  >(KYCApplicationStatusDocument, options);
}
export function useKYCApplicationStatusLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    Types.KYCApplicationStatusQuery,
    Types.KYCApplicationStatusQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    Types.KYCApplicationStatusQuery,
    Types.KYCApplicationStatusQueryVariables
  >(KYCApplicationStatusDocument, options);
}
export type KYCApplicationStatusQueryHookResult = ReturnType<
  typeof useKYCApplicationStatusQuery
>;
export type KYCApplicationStatusLazyQueryHookResult = ReturnType<
  typeof useKYCApplicationStatusLazyQuery
>;
export type KYCApplicationStatusQueryResult = Apollo.QueryResult<
  Types.KYCApplicationStatusQuery,
  Types.KYCApplicationStatusQueryVariables
>;
export const KYCOCRResultsDocument = gql`
  query KYCOCRResults($applicantId: String!) {
    KYCOCRResults(applicantId: $applicantId) {
      idDocumentType
      name
      birthday
      address
      addressPref
      addressCity
      addressOther
      zipCode
      idNumber
      expireDate
    }
  }
`;

/**
 * __useKYCOCRResultsQuery__
 *
 * To run a query within a React component, call `useKYCOCRResultsQuery` and pass it any options that fit your needs.
 * When your component renders, `useKYCOCRResultsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useKYCOCRResultsQuery({
 *   variables: {
 *      applicantId: // value for 'applicantId'
 *   },
 * });
 */
export function useKYCOCRResultsQuery(
  baseOptions: Apollo.QueryHookOptions<
    Types.KYCOCRResultsQuery,
    Types.KYCOCRResultsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    Types.KYCOCRResultsQuery,
    Types.KYCOCRResultsQueryVariables
  >(KYCOCRResultsDocument, options);
}
export function useKYCOCRResultsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    Types.KYCOCRResultsQuery,
    Types.KYCOCRResultsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    Types.KYCOCRResultsQuery,
    Types.KYCOCRResultsQueryVariables
  >(KYCOCRResultsDocument, options);
}
export type KYCOCRResultsQueryHookResult = ReturnType<
  typeof useKYCOCRResultsQuery
>;
export type KYCOCRResultsLazyQueryHookResult = ReturnType<
  typeof useKYCOCRResultsLazyQuery
>;
export type KYCOCRResultsQueryResult = Apollo.QueryResult<
  Types.KYCOCRResultsQuery,
  Types.KYCOCRResultsQueryVariables
>;
export const KYCUpdateApplicationStatusDocument = gql`
  query KYCUpdateApplicationStatus {
    KYCUpdateApplicationStatus {
      status
    }
  }
`;

/**
 * __useKYCUpdateApplicationStatusQuery__
 *
 * To run a query within a React component, call `useKYCUpdateApplicationStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useKYCUpdateApplicationStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useKYCUpdateApplicationStatusQuery({
 *   variables: {
 *   },
 * });
 */
export function useKYCUpdateApplicationStatusQuery(
  baseOptions?: Apollo.QueryHookOptions<
    Types.KYCUpdateApplicationStatusQuery,
    Types.KYCUpdateApplicationStatusQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    Types.KYCUpdateApplicationStatusQuery,
    Types.KYCUpdateApplicationStatusQueryVariables
  >(KYCUpdateApplicationStatusDocument, options);
}
export function useKYCUpdateApplicationStatusLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    Types.KYCUpdateApplicationStatusQuery,
    Types.KYCUpdateApplicationStatusQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    Types.KYCUpdateApplicationStatusQuery,
    Types.KYCUpdateApplicationStatusQueryVariables
  >(KYCUpdateApplicationStatusDocument, options);
}
export type KYCUpdateApplicationStatusQueryHookResult = ReturnType<
  typeof useKYCUpdateApplicationStatusQuery
>;
export type KYCUpdateApplicationStatusLazyQueryHookResult = ReturnType<
  typeof useKYCUpdateApplicationStatusLazyQuery
>;
export type KYCUpdateApplicationStatusQueryResult = Apollo.QueryResult<
  Types.KYCUpdateApplicationStatusQuery,
  Types.KYCUpdateApplicationStatusQueryVariables
>;
export const LogoutDocument = gql`
  mutation Logout($token: String!) {
    logout(token: $token)
  }
`;
export type LogoutMutationFn = Apollo.MutationFunction<
  Types.LogoutMutation,
  Types.LogoutMutationVariables
>;

/**
 * __useLogoutMutation__
 *
 * To run a mutation, you first call `useLogoutMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLogoutMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [logoutMutation, { data, loading, error }] = useLogoutMutation({
 *   variables: {
 *      token: // value for 'token'
 *   },
 * });
 */
export function useLogoutMutation(
  baseOptions?: Apollo.MutationHookOptions<
    Types.LogoutMutation,
    Types.LogoutMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    Types.LogoutMutation,
    Types.LogoutMutationVariables
  >(LogoutDocument, options);
}
export type LogoutMutationHookResult = ReturnType<typeof useLogoutMutation>;
export type LogoutMutationResult = Apollo.MutationResult<Types.LogoutMutation>;
export type LogoutMutationOptions = Apollo.BaseMutationOptions<
  Types.LogoutMutation,
  Types.LogoutMutationVariables
>;
export const MerchantsConfigurationDocument = gql`
  query MerchantsConfiguration($arrayOfIds: [String!]!) {
    merchantsConfiguration(merchantIds: $arrayOfIds) {
      merchantId
      perKind {
        kind
        threshold
        installmentCount
      }
    }
  }
`;

/**
 * __useMerchantsConfigurationQuery__
 *
 * To run a query within a React component, call `useMerchantsConfigurationQuery` and pass it any options that fit your needs.
 * When your component renders, `useMerchantsConfigurationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMerchantsConfigurationQuery({
 *   variables: {
 *      arrayOfIds: // value for 'arrayOfIds'
 *   },
 * });
 */
export function useMerchantsConfigurationQuery(
  baseOptions: Apollo.QueryHookOptions<
    Types.MerchantsConfigurationQuery,
    Types.MerchantsConfigurationQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    Types.MerchantsConfigurationQuery,
    Types.MerchantsConfigurationQueryVariables
  >(MerchantsConfigurationDocument, options);
}
export function useMerchantsConfigurationLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    Types.MerchantsConfigurationQuery,
    Types.MerchantsConfigurationQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    Types.MerchantsConfigurationQuery,
    Types.MerchantsConfigurationQueryVariables
  >(MerchantsConfigurationDocument, options);
}
export type MerchantsConfigurationQueryHookResult = ReturnType<
  typeof useMerchantsConfigurationQuery
>;
export type MerchantsConfigurationLazyQueryHookResult = ReturnType<
  typeof useMerchantsConfigurationLazyQuery
>;
export type MerchantsConfigurationQueryResult = Apollo.QueryResult<
  Types.MerchantsConfigurationQuery,
  Types.MerchantsConfigurationQueryVariables
>;
export const MultiPayContractsDocument = gql`
  query MultiPayContracts($status: [MultipayContractStatus!]) {
    multipayContracts(status: $status) {
      id
      status
      approvalDecisionAt
      principal
      contractFee
      contractFeeRate
      currency
      charges {
        order
        id
        pushAt
        principal
        fee
        currency
        isPushed
      }
    }
  }
`;

/**
 * __useMultiPayContractsQuery__
 *
 * To run a query within a React component, call `useMultiPayContractsQuery` and pass it any options that fit your needs.
 * When your component renders, `useMultiPayContractsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMultiPayContractsQuery({
 *   variables: {
 *      status: // value for 'status'
 *   },
 * });
 */
export function useMultiPayContractsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    Types.MultiPayContractsQuery,
    Types.MultiPayContractsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    Types.MultiPayContractsQuery,
    Types.MultiPayContractsQueryVariables
  >(MultiPayContractsDocument, options);
}
export function useMultiPayContractsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    Types.MultiPayContractsQuery,
    Types.MultiPayContractsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    Types.MultiPayContractsQuery,
    Types.MultiPayContractsQueryVariables
  >(MultiPayContractsDocument, options);
}
export type MultiPayContractsQueryHookResult = ReturnType<
  typeof useMultiPayContractsQuery
>;
export type MultiPayContractsLazyQueryHookResult = ReturnType<
  typeof useMultiPayContractsLazyQuery
>;
export type MultiPayContractsQueryResult = Apollo.QueryResult<
  Types.MultiPayContractsQuery,
  Types.MultiPayContractsQueryVariables
>;
export const MultiPayContractDocument = gql`
  query MultiPayContract($id: String!) {
    multipayContract(id: $id) {
      id
      status
      approvalDecisionAt
      principal
      contractFee
      contractFeeRate
      currency
      charges {
        order
        id
        pushAt
        principal
        fee
        currency
        isPushed
      }
    }
  }
`;

/**
 * __useMultiPayContractQuery__
 *
 * To run a query within a React component, call `useMultiPayContractQuery` and pass it any options that fit your needs.
 * When your component renders, `useMultiPayContractQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMultiPayContractQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useMultiPayContractQuery(
  baseOptions: Apollo.QueryHookOptions<
    Types.MultiPayContractQuery,
    Types.MultiPayContractQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    Types.MultiPayContractQuery,
    Types.MultiPayContractQueryVariables
  >(MultiPayContractDocument, options);
}
export function useMultiPayContractLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    Types.MultiPayContractQuery,
    Types.MultiPayContractQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    Types.MultiPayContractQuery,
    Types.MultiPayContractQueryVariables
  >(MultiPayContractDocument, options);
}
export type MultiPayContractQueryHookResult = ReturnType<
  typeof useMultiPayContractQuery
>;
export type MultiPayContractLazyQueryHookResult = ReturnType<
  typeof useMultiPayContractLazyQuery
>;
export type MultiPayContractQueryResult = Apollo.QueryResult<
  Types.MultiPayContractQuery,
  Types.MultiPayContractQueryVariables
>;
export const OptInAppleCreditDocument = gql`
  mutation OptInAppleCredit {
    optInAppleCredit {
      status
      statusDetails
    }
  }
`;
export type OptInAppleCreditMutationFn = Apollo.MutationFunction<
  Types.OptInAppleCreditMutation,
  Types.OptInAppleCreditMutationVariables
>;

/**
 * __useOptInAppleCreditMutation__
 *
 * To run a mutation, you first call `useOptInAppleCreditMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useOptInAppleCreditMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [optInAppleCreditMutation, { data, loading, error }] = useOptInAppleCreditMutation({
 *   variables: {
 *   },
 * });
 */
export function useOptInAppleCreditMutation(
  baseOptions?: Apollo.MutationHookOptions<
    Types.OptInAppleCreditMutation,
    Types.OptInAppleCreditMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    Types.OptInAppleCreditMutation,
    Types.OptInAppleCreditMutationVariables
  >(OptInAppleCreditDocument, options);
}
export type OptInAppleCreditMutationHookResult = ReturnType<
  typeof useOptInAppleCreditMutation
>;
export type OptInAppleCreditMutationResult = Apollo.MutationResult<
  Types.OptInAppleCreditMutation
>;
export type OptInAppleCreditMutationOptions = Apollo.BaseMutationOptions<
  Types.OptInAppleCreditMutation,
  Types.OptInAppleCreditMutationVariables
>;
export const PaymentsDocument = gql`
  query Payments($offset: Int = 0, $limit: Int = 10) {
    payments(offset: $offset, limit: $limit) {
      id
      storeName
      amount
      currency
      status
      createdAt
    }
  }
`;

/**
 * __usePaymentsQuery__
 *
 * To run a query within a React component, call `usePaymentsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePaymentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePaymentsQuery({
 *   variables: {
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function usePaymentsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    Types.PaymentsQuery,
    Types.PaymentsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<Types.PaymentsQuery, Types.PaymentsQueryVariables>(
    PaymentsDocument,
    options
  );
}
export function usePaymentsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    Types.PaymentsQuery,
    Types.PaymentsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<Types.PaymentsQuery, Types.PaymentsQueryVariables>(
    PaymentsDocument,
    options
  );
}
export type PaymentsQueryHookResult = ReturnType<typeof usePaymentsQuery>;
export type PaymentsLazyQueryHookResult = ReturnType<
  typeof usePaymentsLazyQuery
>;
export type PaymentsQueryResult = Apollo.QueryResult<
  Types.PaymentsQuery,
  Types.PaymentsQueryVariables
>;
export const PEPStatusDocument = gql`
  query PEPStatus {
    PEPStatus {
      isExposed
    }
  }
`;

/**
 * __usePEPStatusQuery__
 *
 * To run a query within a React component, call `usePEPStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `usePEPStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePEPStatusQuery({
 *   variables: {
 *   },
 * });
 */
export function usePEPStatusQuery(
  baseOptions?: Apollo.QueryHookOptions<
    Types.PEPStatusQuery,
    Types.PEPStatusQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<Types.PEPStatusQuery, Types.PEPStatusQueryVariables>(
    PEPStatusDocument,
    options
  );
}
export function usePEPStatusLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    Types.PEPStatusQuery,
    Types.PEPStatusQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    Types.PEPStatusQuery,
    Types.PEPStatusQueryVariables
  >(PEPStatusDocument, options);
}
export type PEPStatusQueryHookResult = ReturnType<typeof usePEPStatusQuery>;
export type PEPStatusLazyQueryHookResult = ReturnType<
  typeof usePEPStatusLazyQuery
>;
export type PEPStatusQueryResult = Apollo.QueryResult<
  Types.PEPStatusQuery,
  Types.PEPStatusQueryVariables
>;
export const PlusContractsDocument = gql`
  query PlusContracts {
    plusContracts {
      id
      status
      amount
      currency
      createdAt
      contractedAt
      dueAt
    }
  }
`;

/**
 * __usePlusContractsQuery__
 *
 * To run a query within a React component, call `usePlusContractsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePlusContractsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePlusContractsQuery({
 *   variables: {
 *   },
 * });
 */
export function usePlusContractsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    Types.PlusContractsQuery,
    Types.PlusContractsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    Types.PlusContractsQuery,
    Types.PlusContractsQueryVariables
  >(PlusContractsDocument, options);
}
export function usePlusContractsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    Types.PlusContractsQuery,
    Types.PlusContractsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    Types.PlusContractsQuery,
    Types.PlusContractsQueryVariables
  >(PlusContractsDocument, options);
}
export type PlusContractsQueryHookResult = ReturnType<
  typeof usePlusContractsQuery
>;
export type PlusContractsLazyQueryHookResult = ReturnType<
  typeof usePlusContractsLazyQuery
>;
export type PlusContractsQueryResult = Apollo.QueryResult<
  Types.PlusContractsQuery,
  Types.PlusContractsQueryVariables
>;
export const PlusContractDocument = gql`
  query PlusContract($id: String!) {
    plusContract(id: $id) {
      id
      status
      amount
      currency
      createdAt
      contractedAt
      dueAt
    }
  }
`;

/**
 * __usePlusContractQuery__
 *
 * To run a query within a React component, call `usePlusContractQuery` and pass it any options that fit your needs.
 * When your component renders, `usePlusContractQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePlusContractQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function usePlusContractQuery(
  baseOptions: Apollo.QueryHookOptions<
    Types.PlusContractQuery,
    Types.PlusContractQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    Types.PlusContractQuery,
    Types.PlusContractQueryVariables
  >(PlusContractDocument, options);
}
export function usePlusContractLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    Types.PlusContractQuery,
    Types.PlusContractQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    Types.PlusContractQuery,
    Types.PlusContractQueryVariables
  >(PlusContractDocument, options);
}
export type PlusContractQueryHookResult = ReturnType<
  typeof usePlusContractQuery
>;
export type PlusContractLazyQueryHookResult = ReturnType<
  typeof usePlusContractLazyQuery
>;
export type PlusContractQueryResult = Apollo.QueryResult<
  Types.PlusContractQuery,
  Types.PlusContractQueryVariables
>;
export const GetPushNotificationsDocument = gql`
  query GetPushNotifications {
    getPushNotifications {
      categories {
        category
        enabled
      }
    }
  }
`;

/**
 * __useGetPushNotificationsQuery__
 *
 * To run a query within a React component, call `useGetPushNotificationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPushNotificationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPushNotificationsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetPushNotificationsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    Types.GetPushNotificationsQuery,
    Types.GetPushNotificationsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    Types.GetPushNotificationsQuery,
    Types.GetPushNotificationsQueryVariables
  >(GetPushNotificationsDocument, options);
}
export function useGetPushNotificationsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    Types.GetPushNotificationsQuery,
    Types.GetPushNotificationsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    Types.GetPushNotificationsQuery,
    Types.GetPushNotificationsQueryVariables
  >(GetPushNotificationsDocument, options);
}
export type GetPushNotificationsQueryHookResult = ReturnType<
  typeof useGetPushNotificationsQuery
>;
export type GetPushNotificationsLazyQueryHookResult = ReturnType<
  typeof useGetPushNotificationsLazyQuery
>;
export type GetPushNotificationsQueryResult = Apollo.QueryResult<
  Types.GetPushNotificationsQuery,
  Types.GetPushNotificationsQueryVariables
>;
export const SetPushNotificationsByConsumerDocument = gql`
  mutation SetPushNotificationsByConsumer($preferences: PushPreferences!) {
    setPushNotificationsByConsumer(preferences: $preferences) {
      categories {
        category
        enabled
      }
    }
  }
`;
export type SetPushNotificationsByConsumerMutationFn = Apollo.MutationFunction<
  Types.SetPushNotificationsByConsumerMutation,
  Types.SetPushNotificationsByConsumerMutationVariables
>;

/**
 * __useSetPushNotificationsByConsumerMutation__
 *
 * To run a mutation, you first call `useSetPushNotificationsByConsumerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetPushNotificationsByConsumerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setPushNotificationsByConsumerMutation, { data, loading, error }] = useSetPushNotificationsByConsumerMutation({
 *   variables: {
 *      preferences: // value for 'preferences'
 *   },
 * });
 */
export function useSetPushNotificationsByConsumerMutation(
  baseOptions?: Apollo.MutationHookOptions<
    Types.SetPushNotificationsByConsumerMutation,
    Types.SetPushNotificationsByConsumerMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    Types.SetPushNotificationsByConsumerMutation,
    Types.SetPushNotificationsByConsumerMutationVariables
  >(SetPushNotificationsByConsumerDocument, options);
}
export type SetPushNotificationsByConsumerMutationHookResult = ReturnType<
  typeof useSetPushNotificationsByConsumerMutation
>;
export type SetPushNotificationsByConsumerMutationResult = Apollo.MutationResult<
  Types.SetPushNotificationsByConsumerMutation
>;
export type SetPushNotificationsByConsumerMutationOptions = Apollo.BaseMutationOptions<
  Types.SetPushNotificationsByConsumerMutation,
  Types.SetPushNotificationsByConsumerMutationVariables
>;
export const SetPushNotificationsByConsumerAndCategoryDocument = gql`
  mutation SetPushNotificationsByConsumerAndCategory(
    $category: MessagingHubPushNotificationCategory!
    $enabled: Boolean!
  ) {
    setPushNotificationsByConsumerAndCategory(
      category: $category
      enabled: $enabled
    ) {
      category
      enabled
    }
  }
`;
export type SetPushNotificationsByConsumerAndCategoryMutationFn = Apollo.MutationFunction<
  Types.SetPushNotificationsByConsumerAndCategoryMutation,
  Types.SetPushNotificationsByConsumerAndCategoryMutationVariables
>;

/**
 * __useSetPushNotificationsByConsumerAndCategoryMutation__
 *
 * To run a mutation, you first call `useSetPushNotificationsByConsumerAndCategoryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetPushNotificationsByConsumerAndCategoryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setPushNotificationsByConsumerAndCategoryMutation, { data, loading, error }] = useSetPushNotificationsByConsumerAndCategoryMutation({
 *   variables: {
 *      category: // value for 'category'
 *      enabled: // value for 'enabled'
 *   },
 * });
 */
export function useSetPushNotificationsByConsumerAndCategoryMutation(
  baseOptions?: Apollo.MutationHookOptions<
    Types.SetPushNotificationsByConsumerAndCategoryMutation,
    Types.SetPushNotificationsByConsumerAndCategoryMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    Types.SetPushNotificationsByConsumerAndCategoryMutation,
    Types.SetPushNotificationsByConsumerAndCategoryMutationVariables
  >(SetPushNotificationsByConsumerAndCategoryDocument, options);
}
export type SetPushNotificationsByConsumerAndCategoryMutationHookResult = ReturnType<
  typeof useSetPushNotificationsByConsumerAndCategoryMutation
>;
export type SetPushNotificationsByConsumerAndCategoryMutationResult = Apollo.MutationResult<
  Types.SetPushNotificationsByConsumerAndCategoryMutation
>;
export type SetPushNotificationsByConsumerAndCategoryMutationOptions = Apollo.BaseMutationOptions<
  Types.SetPushNotificationsByConsumerAndCategoryMutation,
  Types.SetPushNotificationsByConsumerAndCategoryMutationVariables
>;
export const RegisterLiquidApplicationInfoDocument = gql`
  mutation RegisterLiquidApplicationInfo($data: CreateKYCApplicationRequest!) {
    registerLiquidApplicationInfo(data: $data) {
      ok
    }
  }
`;
export type RegisterLiquidApplicationInfoMutationFn = Apollo.MutationFunction<
  Types.RegisterLiquidApplicationInfoMutation,
  Types.RegisterLiquidApplicationInfoMutationVariables
>;

/**
 * __useRegisterLiquidApplicationInfoMutation__
 *
 * To run a mutation, you first call `useRegisterLiquidApplicationInfoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRegisterLiquidApplicationInfoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [registerLiquidApplicationInfoMutation, { data, loading, error }] = useRegisterLiquidApplicationInfoMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useRegisterLiquidApplicationInfoMutation(
  baseOptions?: Apollo.MutationHookOptions<
    Types.RegisterLiquidApplicationInfoMutation,
    Types.RegisterLiquidApplicationInfoMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    Types.RegisterLiquidApplicationInfoMutation,
    Types.RegisterLiquidApplicationInfoMutationVariables
  >(RegisterLiquidApplicationInfoDocument, options);
}
export type RegisterLiquidApplicationInfoMutationHookResult = ReturnType<
  typeof useRegisterLiquidApplicationInfoMutation
>;
export type RegisterLiquidApplicationInfoMutationResult = Apollo.MutationResult<
  Types.RegisterLiquidApplicationInfoMutation
>;
export type RegisterLiquidApplicationInfoMutationOptions = Apollo.BaseMutationOptions<
  Types.RegisterLiquidApplicationInfoMutation,
  Types.RegisterLiquidApplicationInfoMutationVariables
>;
export const RegisterLiquidUpdateApplicationInfoDocument = gql`
  mutation RegisterLiquidUpdateApplicationInfo(
    $data: CreateKYCUpdateApplicationRequest!
  ) {
    registerLiquidUpdateApplicationInfo(data: $data) {
      ok
    }
  }
`;
export type RegisterLiquidUpdateApplicationInfoMutationFn = Apollo.MutationFunction<
  Types.RegisterLiquidUpdateApplicationInfoMutation,
  Types.RegisterLiquidUpdateApplicationInfoMutationVariables
>;

/**
 * __useRegisterLiquidUpdateApplicationInfoMutation__
 *
 * To run a mutation, you first call `useRegisterLiquidUpdateApplicationInfoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRegisterLiquidUpdateApplicationInfoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [registerLiquidUpdateApplicationInfoMutation, { data, loading, error }] = useRegisterLiquidUpdateApplicationInfoMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useRegisterLiquidUpdateApplicationInfoMutation(
  baseOptions?: Apollo.MutationHookOptions<
    Types.RegisterLiquidUpdateApplicationInfoMutation,
    Types.RegisterLiquidUpdateApplicationInfoMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    Types.RegisterLiquidUpdateApplicationInfoMutation,
    Types.RegisterLiquidUpdateApplicationInfoMutationVariables
  >(RegisterLiquidUpdateApplicationInfoDocument, options);
}
export type RegisterLiquidUpdateApplicationInfoMutationHookResult = ReturnType<
  typeof useRegisterLiquidUpdateApplicationInfoMutation
>;
export type RegisterLiquidUpdateApplicationInfoMutationResult = Apollo.MutationResult<
  Types.RegisterLiquidUpdateApplicationInfoMutation
>;
export type RegisterLiquidUpdateApplicationInfoMutationOptions = Apollo.BaseMutationOptions<
  Types.RegisterLiquidUpdateApplicationInfoMutation,
  Types.RegisterLiquidUpdateApplicationInfoMutationVariables
>;
export const RegisterNotificationIdDocument = gql`
  mutation RegisterNotificationId($externalConsumerId: String!) {
    registerNotificationId(externalConsumerId: $externalConsumerId)
  }
`;
export type RegisterNotificationIdMutationFn = Apollo.MutationFunction<
  Types.RegisterNotificationIdMutation,
  Types.RegisterNotificationIdMutationVariables
>;

/**
 * __useRegisterNotificationIdMutation__
 *
 * To run a mutation, you first call `useRegisterNotificationIdMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRegisterNotificationIdMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [registerNotificationIdMutation, { data, loading, error }] = useRegisterNotificationIdMutation({
 *   variables: {
 *      externalConsumerId: // value for 'externalConsumerId'
 *   },
 * });
 */
export function useRegisterNotificationIdMutation(
  baseOptions?: Apollo.MutationHookOptions<
    Types.RegisterNotificationIdMutation,
    Types.RegisterNotificationIdMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    Types.RegisterNotificationIdMutation,
    Types.RegisterNotificationIdMutationVariables
  >(RegisterNotificationIdDocument, options);
}
export type RegisterNotificationIdMutationHookResult = ReturnType<
  typeof useRegisterNotificationIdMutation
>;
export type RegisterNotificationIdMutationResult = Apollo.MutationResult<
  Types.RegisterNotificationIdMutation
>;
export type RegisterNotificationIdMutationOptions = Apollo.BaseMutationOptions<
  Types.RegisterNotificationIdMutation,
  Types.RegisterNotificationIdMutationVariables
>;
export const ResetEmailDocument = gql`
  mutation ResetEmail($email: String!) {
    resetEmail(email: $email)
  }
`;
export type ResetEmailMutationFn = Apollo.MutationFunction<
  Types.ResetEmailMutation,
  Types.ResetEmailMutationVariables
>;

/**
 * __useResetEmailMutation__
 *
 * To run a mutation, you first call `useResetEmailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResetEmailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resetEmailMutation, { data, loading, error }] = useResetEmailMutation({
 *   variables: {
 *      email: // value for 'email'
 *   },
 * });
 */
export function useResetEmailMutation(
  baseOptions?: Apollo.MutationHookOptions<
    Types.ResetEmailMutation,
    Types.ResetEmailMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    Types.ResetEmailMutation,
    Types.ResetEmailMutationVariables
  >(ResetEmailDocument, options);
}
export type ResetEmailMutationHookResult = ReturnType<
  typeof useResetEmailMutation
>;
export type ResetEmailMutationResult = Apollo.MutationResult<
  Types.ResetEmailMutation
>;
export type ResetEmailMutationOptions = Apollo.BaseMutationOptions<
  Types.ResetEmailMutation,
  Types.ResetEmailMutationVariables
>;
export const ResetPhoneDocument = gql`
  mutation ResetPhone {
    resetPhone
  }
`;
export type ResetPhoneMutationFn = Apollo.MutationFunction<
  Types.ResetPhoneMutation,
  Types.ResetPhoneMutationVariables
>;

/**
 * __useResetPhoneMutation__
 *
 * To run a mutation, you first call `useResetPhoneMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResetPhoneMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resetPhoneMutation, { data, loading, error }] = useResetPhoneMutation({
 *   variables: {
 *   },
 * });
 */
export function useResetPhoneMutation(
  baseOptions?: Apollo.MutationHookOptions<
    Types.ResetPhoneMutation,
    Types.ResetPhoneMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    Types.ResetPhoneMutation,
    Types.ResetPhoneMutationVariables
  >(ResetPhoneDocument, options);
}
export type ResetPhoneMutationHookResult = ReturnType<
  typeof useResetPhoneMutation
>;
export type ResetPhoneMutationResult = Apollo.MutationResult<
  Types.ResetPhoneMutation
>;
export type ResetPhoneMutationOptions = Apollo.BaseMutationOptions<
  Types.ResetPhoneMutation,
  Types.ResetPhoneMutationVariables
>;
export const ConsumerStatusSummaryDocument = gql`
  query ConsumerStatusSummary {
    KYCApplicationStatus {
      status
    }
    houkatsuStatus {
      status
    }
    appleCreditStatus {
      ...appleStatusResponseData
    }
    PEPStatus {
      isExposed
    }
    NLPMigrationStatus {
      status
    }
  }
  ${appleStatusResponseDataFragmentDoc}
`;

/**
 * __useConsumerStatusSummaryQuery__
 *
 * To run a query within a React component, call `useConsumerStatusSummaryQuery` and pass it any options that fit your needs.
 * When your component renders, `useConsumerStatusSummaryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useConsumerStatusSummaryQuery({
 *   variables: {
 *   },
 * });
 */
export function useConsumerStatusSummaryQuery(
  baseOptions?: Apollo.QueryHookOptions<
    Types.ConsumerStatusSummaryQuery,
    Types.ConsumerStatusSummaryQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    Types.ConsumerStatusSummaryQuery,
    Types.ConsumerStatusSummaryQueryVariables
  >(ConsumerStatusSummaryDocument, options);
}
export function useConsumerStatusSummaryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    Types.ConsumerStatusSummaryQuery,
    Types.ConsumerStatusSummaryQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    Types.ConsumerStatusSummaryQuery,
    Types.ConsumerStatusSummaryQueryVariables
  >(ConsumerStatusSummaryDocument, options);
}
export type ConsumerStatusSummaryQueryHookResult = ReturnType<
  typeof useConsumerStatusSummaryQuery
>;
export type ConsumerStatusSummaryLazyQueryHookResult = ReturnType<
  typeof useConsumerStatusSummaryLazyQuery
>;
export type ConsumerStatusSummaryQueryResult = Apollo.QueryResult<
  Types.ConsumerStatusSummaryQuery,
  Types.ConsumerStatusSummaryQueryVariables
>;
export const PaidyPlusStatusDataDocument = gql`
  query PaidyPlusStatusData {
    KYCApplicationStatus {
      status
    }
    houkatsuStatus {
      status
    }
    appleCreditStatus {
      status
      statusDetails
    }
    PEPStatus {
      isExposed
    }
  }
`;

/**
 * __usePaidyPlusStatusDataQuery__
 *
 * To run a query within a React component, call `usePaidyPlusStatusDataQuery` and pass it any options that fit your needs.
 * When your component renders, `usePaidyPlusStatusDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePaidyPlusStatusDataQuery({
 *   variables: {
 *   },
 * });
 */
export function usePaidyPlusStatusDataQuery(
  baseOptions?: Apollo.QueryHookOptions<
    Types.PaidyPlusStatusDataQuery,
    Types.PaidyPlusStatusDataQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    Types.PaidyPlusStatusDataQuery,
    Types.PaidyPlusStatusDataQueryVariables
  >(PaidyPlusStatusDataDocument, options);
}
export function usePaidyPlusStatusDataLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    Types.PaidyPlusStatusDataQuery,
    Types.PaidyPlusStatusDataQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    Types.PaidyPlusStatusDataQuery,
    Types.PaidyPlusStatusDataQueryVariables
  >(PaidyPlusStatusDataDocument, options);
}
export type PaidyPlusStatusDataQueryHookResult = ReturnType<
  typeof usePaidyPlusStatusDataQuery
>;
export type PaidyPlusStatusDataLazyQueryHookResult = ReturnType<
  typeof usePaidyPlusStatusDataLazyQuery
>;
export type PaidyPlusStatusDataQueryResult = Apollo.QueryResult<
  Types.PaidyPlusStatusDataQuery,
  Types.PaidyPlusStatusDataQueryVariables
>;
export const SetPACDataDocument = gql`
  mutation SetPACData(
    $salary: Int!
    $numberOfDependents: NumberOfDependents!
    $rentOrMortgage: RentOrMortgage!
  ) {
    setPACData(
      salary: $salary
      numberOfDependents: $numberOfDependents
      rentOrMortgage: $rentOrMortgage
    )
  }
`;
export type SetPACDataMutationFn = Apollo.MutationFunction<
  Types.SetPACDataMutation,
  Types.SetPACDataMutationVariables
>;

/**
 * __useSetPACDataMutation__
 *
 * To run a mutation, you first call `useSetPACDataMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetPACDataMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setPacDataMutation, { data, loading, error }] = useSetPACDataMutation({
 *   variables: {
 *      salary: // value for 'salary'
 *      numberOfDependents: // value for 'numberOfDependents'
 *      rentOrMortgage: // value for 'rentOrMortgage'
 *   },
 * });
 */
export function useSetPACDataMutation(
  baseOptions?: Apollo.MutationHookOptions<
    Types.SetPACDataMutation,
    Types.SetPACDataMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    Types.SetPACDataMutation,
    Types.SetPACDataMutationVariables
  >(SetPACDataDocument, options);
}
export type SetPACDataMutationHookResult = ReturnType<
  typeof useSetPACDataMutation
>;
export type SetPACDataMutationResult = Apollo.MutationResult<
  Types.SetPACDataMutation
>;
export type SetPACDataMutationOptions = Apollo.BaseMutationOptions<
  Types.SetPACDataMutation,
  Types.SetPACDataMutationVariables
>;
export const SetPEPStatusDocument = gql`
  mutation SetPEPStatus($isExposed: Boolean!) {
    setPEPStatus(isExposed: $isExposed)
  }
`;
export type SetPEPStatusMutationFn = Apollo.MutationFunction<
  Types.SetPEPStatusMutation,
  Types.SetPEPStatusMutationVariables
>;

/**
 * __useSetPEPStatusMutation__
 *
 * To run a mutation, you first call `useSetPEPStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetPEPStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setPepStatusMutation, { data, loading, error }] = useSetPEPStatusMutation({
 *   variables: {
 *      isExposed: // value for 'isExposed'
 *   },
 * });
 */
export function useSetPEPStatusMutation(
  baseOptions?: Apollo.MutationHookOptions<
    Types.SetPEPStatusMutation,
    Types.SetPEPStatusMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    Types.SetPEPStatusMutation,
    Types.SetPEPStatusMutationVariables
  >(SetPEPStatusDocument, options);
}
export type SetPEPStatusMutationHookResult = ReturnType<
  typeof useSetPEPStatusMutation
>;
export type SetPEPStatusMutationResult = Apollo.MutationResult<
  Types.SetPEPStatusMutation
>;
export type SetPEPStatusMutationOptions = Apollo.BaseMutationOptions<
  Types.SetPEPStatusMutation,
  Types.SetPEPStatusMutationVariables
>;
export const setSpendLimitDocument = gql`
  mutation setSpendLimit($amount: Float!) {
    setSpendLimit(selected: $amount) {
      ...spendLimitData
    }
  }
  ${spendLimitDataFragmentDoc}
`;
export type setSpendLimitMutationFn = Apollo.MutationFunction<
  Types.setSpendLimitMutation,
  Types.setSpendLimitMutationVariables
>;

/**
 * __usesetSpendLimitMutation__
 *
 * To run a mutation, you first call `usesetSpendLimitMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usesetSpendLimitMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setSpendLimitMutation, { data, loading, error }] = usesetSpendLimitMutation({
 *   variables: {
 *      amount: // value for 'amount'
 *   },
 * });
 */
export function usesetSpendLimitMutation(
  baseOptions?: Apollo.MutationHookOptions<
    Types.setSpendLimitMutation,
    Types.setSpendLimitMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    Types.setSpendLimitMutation,
    Types.setSpendLimitMutationVariables
  >(setSpendLimitDocument, options);
}
export type setSpendLimitMutationHookResult = ReturnType<
  typeof usesetSpendLimitMutation
>;
export type setSpendLimitMutationResult = Apollo.MutationResult<
  Types.setSpendLimitMutation
>;
export type setSpendLimitMutationOptions = Apollo.BaseMutationOptions<
  Types.setSpendLimitMutation,
  Types.setSpendLimitMutationVariables
>;
export const ActiveSettlementMethodDocument = gql`
  query ActiveSettlementMethod($billingCycle: String!) {
    activeSettlementMethod(billingCycle: $billingCycle) {
      settlementMethods {
        autoDebit {
          status
          nextPullDate
          nextAutoDebitByDate
          accountAvailability
        }
        combini {
          status
          settlementPeriodEnd
        }
        van {
          status
          settlementPeriodEnd
        }
      }
    }
  }
`;

/**
 * __useActiveSettlementMethodQuery__
 *
 * To run a query within a React component, call `useActiveSettlementMethodQuery` and pass it any options that fit your needs.
 * When your component renders, `useActiveSettlementMethodQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useActiveSettlementMethodQuery({
 *   variables: {
 *      billingCycle: // value for 'billingCycle'
 *   },
 * });
 */
export function useActiveSettlementMethodQuery(
  baseOptions: Apollo.QueryHookOptions<
    Types.ActiveSettlementMethodQuery,
    Types.ActiveSettlementMethodQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    Types.ActiveSettlementMethodQuery,
    Types.ActiveSettlementMethodQueryVariables
  >(ActiveSettlementMethodDocument, options);
}
export function useActiveSettlementMethodLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    Types.ActiveSettlementMethodQuery,
    Types.ActiveSettlementMethodQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    Types.ActiveSettlementMethodQuery,
    Types.ActiveSettlementMethodQueryVariables
  >(ActiveSettlementMethodDocument, options);
}
export type ActiveSettlementMethodQueryHookResult = ReturnType<
  typeof useActiveSettlementMethodQuery
>;
export type ActiveSettlementMethodLazyQueryHookResult = ReturnType<
  typeof useActiveSettlementMethodLazyQuery
>;
export type ActiveSettlementMethodQueryResult = Apollo.QueryResult<
  Types.ActiveSettlementMethodQuery,
  Types.ActiveSettlementMethodQueryVariables
>;
export const SetDesiredActiveSettlementMethodDocument = gql`
  mutation SetDesiredActiveSettlementMethod(
    $billingCycle: String!
    $desiredSettlementMethod: DesiredSettlementMethod!
  ) {
    setDesiredActiveSettlementMethod(
      billingCycle: $billingCycle
      desiredSettlementMethod: $desiredSettlementMethod
    ) {
      state {
        settlementMethods {
          autoDebit {
            status
            nextPullDate
            nextAutoDebitByDate
            accountAvailability
          }
          combini {
            status
          }
          van {
            status
          }
        }
      }
      result
    }
  }
`;
export type SetDesiredActiveSettlementMethodMutationFn = Apollo.MutationFunction<
  Types.SetDesiredActiveSettlementMethodMutation,
  Types.SetDesiredActiveSettlementMethodMutationVariables
>;

/**
 * __useSetDesiredActiveSettlementMethodMutation__
 *
 * To run a mutation, you first call `useSetDesiredActiveSettlementMethodMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetDesiredActiveSettlementMethodMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setDesiredActiveSettlementMethodMutation, { data, loading, error }] = useSetDesiredActiveSettlementMethodMutation({
 *   variables: {
 *      billingCycle: // value for 'billingCycle'
 *      desiredSettlementMethod: // value for 'desiredSettlementMethod'
 *   },
 * });
 */
export function useSetDesiredActiveSettlementMethodMutation(
  baseOptions?: Apollo.MutationHookOptions<
    Types.SetDesiredActiveSettlementMethodMutation,
    Types.SetDesiredActiveSettlementMethodMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    Types.SetDesiredActiveSettlementMethodMutation,
    Types.SetDesiredActiveSettlementMethodMutationVariables
  >(SetDesiredActiveSettlementMethodDocument, options);
}
export type SetDesiredActiveSettlementMethodMutationHookResult = ReturnType<
  typeof useSetDesiredActiveSettlementMethodMutation
>;
export type SetDesiredActiveSettlementMethodMutationResult = Apollo.MutationResult<
  Types.SetDesiredActiveSettlementMethodMutation
>;
export type SetDesiredActiveSettlementMethodMutationOptions = Apollo.BaseMutationOptions<
  Types.SetDesiredActiveSettlementMethodMutation,
  Types.SetDesiredActiveSettlementMethodMutationVariables
>;
export const SignOutDocument = gql`
  mutation SignOut {
    signOut
  }
`;
export type SignOutMutationFn = Apollo.MutationFunction<
  Types.SignOutMutation,
  Types.SignOutMutationVariables
>;

/**
 * __useSignOutMutation__
 *
 * To run a mutation, you first call `useSignOutMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSignOutMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [signOutMutation, { data, loading, error }] = useSignOutMutation({
 *   variables: {
 *   },
 * });
 */
export function useSignOutMutation(
  baseOptions?: Apollo.MutationHookOptions<
    Types.SignOutMutation,
    Types.SignOutMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    Types.SignOutMutation,
    Types.SignOutMutationVariables
  >(SignOutDocument, options);
}
export type SignOutMutationHookResult = ReturnType<typeof useSignOutMutation>;
export type SignOutMutationResult = Apollo.MutationResult<
  Types.SignOutMutation
>;
export type SignOutMutationOptions = Apollo.BaseMutationOptions<
  Types.SignOutMutation,
  Types.SignOutMutationVariables
>;
export const SingleBillStatementDocument = gql`
  query SingleBillStatement($id: String!) {
    billStatement(id: $id) {
      ...billStatement
      charges {
        ...chargeDataOfBillStatement
        installmentPlanOptions {
          available {
            ...availableInstallmentPlanData
          }
          unavailable {
            kind
            reason {
              threshold
              code
              details {
                kind
                installments {
                  id
                  amount
                  dueDate
                  dueNext
                }
              }
            }
          }
        }
      }
    }
  }
  ${billStatementFragmentDoc}
  ${chargeDataOfBillStatementFragmentDoc}
  ${availableInstallmentPlanDataFragmentDoc}
`;

/**
 * __useSingleBillStatementQuery__
 *
 * To run a query within a React component, call `useSingleBillStatementQuery` and pass it any options that fit your needs.
 * When your component renders, `useSingleBillStatementQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSingleBillStatementQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useSingleBillStatementQuery(
  baseOptions: Apollo.QueryHookOptions<
    Types.SingleBillStatementQuery,
    Types.SingleBillStatementQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    Types.SingleBillStatementQuery,
    Types.SingleBillStatementQueryVariables
  >(SingleBillStatementDocument, options);
}
export function useSingleBillStatementLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    Types.SingleBillStatementQuery,
    Types.SingleBillStatementQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    Types.SingleBillStatementQuery,
    Types.SingleBillStatementQueryVariables
  >(SingleBillStatementDocument, options);
}
export type SingleBillStatementQueryHookResult = ReturnType<
  typeof useSingleBillStatementQuery
>;
export type SingleBillStatementLazyQueryHookResult = ReturnType<
  typeof useSingleBillStatementLazyQuery
>;
export type SingleBillStatementQueryResult = Apollo.QueryResult<
  Types.SingleBillStatementQuery,
  Types.SingleBillStatementQueryVariables
>;
export const SpendLimitDocument = gql`
  query SpendLimit {
    spendLimit {
      ...spendLimitData
    }
  }
  ${spendLimitDataFragmentDoc}
`;

/**
 * __useSpendLimitQuery__
 *
 * To run a query within a React component, call `useSpendLimitQuery` and pass it any options that fit your needs.
 * When your component renders, `useSpendLimitQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSpendLimitQuery({
 *   variables: {
 *   },
 * });
 */
export function useSpendLimitQuery(
  baseOptions?: Apollo.QueryHookOptions<
    Types.SpendLimitQuery,
    Types.SpendLimitQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<Types.SpendLimitQuery, Types.SpendLimitQueryVariables>(
    SpendLimitDocument,
    options
  );
}
export function useSpendLimitLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    Types.SpendLimitQuery,
    Types.SpendLimitQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    Types.SpendLimitQuery,
    Types.SpendLimitQueryVariables
  >(SpendLimitDocument, options);
}
export type SpendLimitQueryHookResult = ReturnType<typeof useSpendLimitQuery>;
export type SpendLimitLazyQueryHookResult = ReturnType<
  typeof useSpendLimitLazyQuery
>;
export type SpendLimitQueryResult = Apollo.QueryResult<
  Types.SpendLimitQuery,
  Types.SpendLimitQueryVariables
>;
export const TransactionDocument = gql`
  query Transaction($id: String!) {
    transaction(id: $id) {
      ...transactionData
    }
  }
  ${transactionDataFragmentDoc}
`;

/**
 * __useTransactionQuery__
 *
 * To run a query within a React component, call `useTransactionQuery` and pass it any options that fit your needs.
 * When your component renders, `useTransactionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTransactionQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useTransactionQuery(
  baseOptions: Apollo.QueryHookOptions<
    Types.TransactionQuery,
    Types.TransactionQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    Types.TransactionQuery,
    Types.TransactionQueryVariables
  >(TransactionDocument, options);
}
export function useTransactionLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    Types.TransactionQuery,
    Types.TransactionQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    Types.TransactionQuery,
    Types.TransactionQueryVariables
  >(TransactionDocument, options);
}
export type TransactionQueryHookResult = ReturnType<typeof useTransactionQuery>;
export type TransactionLazyQueryHookResult = ReturnType<
  typeof useTransactionLazyQuery
>;
export type TransactionQueryResult = Apollo.QueryResult<
  Types.TransactionQuery,
  Types.TransactionQueryVariables
>;
export const UpdateConsumerDocument = gql`
  mutation UpdateConsumer(
    $email: String
    $phone: String
    $name1: String
    $name2: String
    $address: InputAddress
    $dateOfBirth: NaiveDate
  ) {
    updateConsumer(
      email: $email
      phone: $phone
      name1: $name1
      name2: $name2
      address: $address
      dateOfBirth: $dateOfBirth
    ) {
      email
      phone
      name1
      name2
      address {
        line1
        line2
        city
        state
        zip
      }
      dateOfBirth
    }
  }
`;
export type UpdateConsumerMutationFn = Apollo.MutationFunction<
  Types.UpdateConsumerMutation,
  Types.UpdateConsumerMutationVariables
>;

/**
 * __useUpdateConsumerMutation__
 *
 * To run a mutation, you first call `useUpdateConsumerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateConsumerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateConsumerMutation, { data, loading, error }] = useUpdateConsumerMutation({
 *   variables: {
 *      email: // value for 'email'
 *      phone: // value for 'phone'
 *      name1: // value for 'name1'
 *      name2: // value for 'name2'
 *      address: // value for 'address'
 *      dateOfBirth: // value for 'dateOfBirth'
 *   },
 * });
 */
export function useUpdateConsumerMutation(
  baseOptions?: Apollo.MutationHookOptions<
    Types.UpdateConsumerMutation,
    Types.UpdateConsumerMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    Types.UpdateConsumerMutation,
    Types.UpdateConsumerMutationVariables
  >(UpdateConsumerDocument, options);
}
export type UpdateConsumerMutationHookResult = ReturnType<
  typeof useUpdateConsumerMutation
>;
export type UpdateConsumerMutationResult = Apollo.MutationResult<
  Types.UpdateConsumerMutation
>;
export type UpdateConsumerMutationOptions = Apollo.BaseMutationOptions<
  Types.UpdateConsumerMutation,
  Types.UpdateConsumerMutationVariables
>;
export const UpdateLiquidTokenDocument = gql`
  mutation UpdateLiquidToken {
    liquidApplication: createLiquidSdkUpdateApplication {
      token
      applicantId
    }
  }
`;
export type UpdateLiquidTokenMutationFn = Apollo.MutationFunction<
  Types.UpdateLiquidTokenMutation,
  Types.UpdateLiquidTokenMutationVariables
>;

/**
 * __useUpdateLiquidTokenMutation__
 *
 * To run a mutation, you first call `useUpdateLiquidTokenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateLiquidTokenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateLiquidTokenMutation, { data, loading, error }] = useUpdateLiquidTokenMutation({
 *   variables: {
 *   },
 * });
 */
export function useUpdateLiquidTokenMutation(
  baseOptions?: Apollo.MutationHookOptions<
    Types.UpdateLiquidTokenMutation,
    Types.UpdateLiquidTokenMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    Types.UpdateLiquidTokenMutation,
    Types.UpdateLiquidTokenMutationVariables
  >(UpdateLiquidTokenDocument, options);
}
export type UpdateLiquidTokenMutationHookResult = ReturnType<
  typeof useUpdateLiquidTokenMutation
>;
export type UpdateLiquidTokenMutationResult = Apollo.MutationResult<
  Types.UpdateLiquidTokenMutation
>;
export type UpdateLiquidTokenMutationOptions = Apollo.BaseMutationOptions<
  Types.UpdateLiquidTokenMutation,
  Types.UpdateLiquidTokenMutationVariables
>;
export const SettlementBreakdownDocument = gql`
  query SettlementBreakdown($settlementChargeId: String!) {
    settlementBreakdown(settlementChargeId: $settlementChargeId) {
      overdueBillStatements {
        billStatementId
        paidAmount
        billingCycle
        dueAt
      }
      outstandingBillStatementCharges {
        charges {
          ...chargeData
        }
      }
      currentUsageCharges {
        charges {
          ...chargeData
        }
      }
      postSettlementCharges {
        charges {
          ...chargeData
        }
      }
    }
  }
  ${chargeDataFragmentDoc}
`;

/**
 * __useSettlementBreakdownQuery__
 *
 * To run a query within a React component, call `useSettlementBreakdownQuery` and pass it any options that fit your needs.
 * When your component renders, `useSettlementBreakdownQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSettlementBreakdownQuery({
 *   variables: {
 *      settlementChargeId: // value for 'settlementChargeId'
 *   },
 * });
 */
export function useSettlementBreakdownQuery(
  baseOptions: Apollo.QueryHookOptions<
    Types.SettlementBreakdownQuery,
    Types.SettlementBreakdownQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    Types.SettlementBreakdownQuery,
    Types.SettlementBreakdownQueryVariables
  >(SettlementBreakdownDocument, options);
}
export function useSettlementBreakdownLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    Types.SettlementBreakdownQuery,
    Types.SettlementBreakdownQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    Types.SettlementBreakdownQuery,
    Types.SettlementBreakdownQueryVariables
  >(SettlementBreakdownDocument, options);
}
export type SettlementBreakdownQueryHookResult = ReturnType<
  typeof useSettlementBreakdownQuery
>;
export type SettlementBreakdownLazyQueryHookResult = ReturnType<
  typeof useSettlementBreakdownLazyQuery
>;
export type SettlementBreakdownQueryResult = Apollo.QueryResult<
  Types.SettlementBreakdownQuery,
  Types.SettlementBreakdownQueryVariables
>;
export const PayNowSettlementPreviewDocument = gql`
  query PayNowSettlementPreview {
    settlementPreview {
      isSettlementAvailable
      combiniFee
      payableAmount
      overdueBillStatements {
        billStatementId
        overdueAmount
        billingCycle
        dueAt
      }
      outstandingBillStatementCharges {
        charges {
          ...chargeData
        }
        billingCycle
      }
      outstandingBillStatementId
      currentUsageCharges {
        charges {
          ...chargeData
        }
      }
    }
  }
  ${chargeDataFragmentDoc}
`;

/**
 * __usePayNowSettlementPreviewQuery__
 *
 * To run a query within a React component, call `usePayNowSettlementPreviewQuery` and pass it any options that fit your needs.
 * When your component renders, `usePayNowSettlementPreviewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePayNowSettlementPreviewQuery({
 *   variables: {
 *   },
 * });
 */
export function usePayNowSettlementPreviewQuery(
  baseOptions?: Apollo.QueryHookOptions<
    Types.PayNowSettlementPreviewQuery,
    Types.PayNowSettlementPreviewQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    Types.PayNowSettlementPreviewQuery,
    Types.PayNowSettlementPreviewQueryVariables
  >(PayNowSettlementPreviewDocument, options);
}
export function usePayNowSettlementPreviewLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    Types.PayNowSettlementPreviewQuery,
    Types.PayNowSettlementPreviewQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    Types.PayNowSettlementPreviewQuery,
    Types.PayNowSettlementPreviewQueryVariables
  >(PayNowSettlementPreviewDocument, options);
}
export type PayNowSettlementPreviewQueryHookResult = ReturnType<
  typeof usePayNowSettlementPreviewQuery
>;
export type PayNowSettlementPreviewLazyQueryHookResult = ReturnType<
  typeof usePayNowSettlementPreviewLazyQuery
>;
export type PayNowSettlementPreviewQueryResult = Apollo.QueryResult<
  Types.PayNowSettlementPreviewQuery,
  Types.PayNowSettlementPreviewQueryVariables
>;
export const ConsumerUsageSummaryDocument = gql`
  query ConsumerUsageSummary {
    consumerUsageSummary {
      isPayNowAvailable
      totalUsageAmount
      outstandingDebts {
        apple
        paidyPlus
      }
      uncapturedAmount
      payableAmount {
        at
        payableAmount
      }
      monthlyTotalUsages {
        usage
        billingCycle
      }
      monthlyTotalUsagesV3 {
        usage
        billingCycle
      }
      monthlyChargesBreakdown {
        charges {
          ...chargeData
        }
        billingCycle
      }
      recentDebits {
        ...chargeData
      }
      recentSettlements {
        id
        amount
        currency
        description
        kind
        pushedAt
        isPayNowSettlement
        isVanTransferSettlement
        paidBillingCycle
        tier
        metadata {
          createdAt
          source
          byWayOf
          settlementFeeAmount
          transactionId
          transactionItemId
        }
      }
      uncapturedPayments {
        ...paymentData
        tier
      }
      plusCharges {
        id
        amount
        kind
        tier
        description
        pushedAt
        metadata {
          source
          settlementFeeAmount
        }
        payment {
          ...paymentData
        }
      }
    }
  }
  ${chargeDataFragmentDoc}
  ${paymentDataFragmentDoc}
`;

/**
 * __useConsumerUsageSummaryQuery__
 *
 * To run a query within a React component, call `useConsumerUsageSummaryQuery` and pass it any options that fit your needs.
 * When your component renders, `useConsumerUsageSummaryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useConsumerUsageSummaryQuery({
 *   variables: {
 *   },
 * });
 */
export function useConsumerUsageSummaryQuery(
  baseOptions?: Apollo.QueryHookOptions<
    Types.ConsumerUsageSummaryQuery,
    Types.ConsumerUsageSummaryQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    Types.ConsumerUsageSummaryQuery,
    Types.ConsumerUsageSummaryQueryVariables
  >(ConsumerUsageSummaryDocument, options);
}
export function useConsumerUsageSummaryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    Types.ConsumerUsageSummaryQuery,
    Types.ConsumerUsageSummaryQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    Types.ConsumerUsageSummaryQuery,
    Types.ConsumerUsageSummaryQueryVariables
  >(ConsumerUsageSummaryDocument, options);
}
export type ConsumerUsageSummaryQueryHookResult = ReturnType<
  typeof useConsumerUsageSummaryQuery
>;
export type ConsumerUsageSummaryLazyQueryHookResult = ReturnType<
  typeof useConsumerUsageSummaryLazyQuery
>;
export type ConsumerUsageSummaryQueryResult = Apollo.QueryResult<
  Types.ConsumerUsageSummaryQuery,
  Types.ConsumerUsageSummaryQueryVariables
>;
export const PaymentDocument = gql`
  query Payment($id: String!) {
    payment(id: $id) {
      ...paymentData
    }
  }
  ${paymentDataFragmentDoc}
`;

/**
 * __usePaymentQuery__
 *
 * To run a query within a React component, call `usePaymentQuery` and pass it any options that fit your needs.
 * When your component renders, `usePaymentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePaymentQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function usePaymentQuery(
  baseOptions: Apollo.QueryHookOptions<
    Types.PaymentQuery,
    Types.PaymentQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<Types.PaymentQuery, Types.PaymentQueryVariables>(
    PaymentDocument,
    options
  );
}
export function usePaymentLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    Types.PaymentQuery,
    Types.PaymentQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<Types.PaymentQuery, Types.PaymentQueryVariables>(
    PaymentDocument,
    options
  );
}
export type PaymentQueryHookResult = ReturnType<typeof usePaymentQuery>;
export type PaymentLazyQueryHookResult = ReturnType<typeof usePaymentLazyQuery>;
export type PaymentQueryResult = Apollo.QueryResult<
  Types.PaymentQuery,
  Types.PaymentQueryVariables
>;
export const VANDocument = gql`
  query VAN {
    VAN {
      bankName
      branchName
      accountType
      accountHolder
      accountNumber
    }
  }
`;

/**
 * __useVANQuery__
 *
 * To run a query within a React component, call `useVANQuery` and pass it any options that fit your needs.
 * When your component renders, `useVANQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useVANQuery({
 *   variables: {
 *   },
 * });
 */
export function useVANQuery(
  baseOptions?: Apollo.QueryHookOptions<Types.VANQuery, Types.VANQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<Types.VANQuery, Types.VANQueryVariables>(
    VANDocument,
    options
  );
}
export function useVANLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    Types.VANQuery,
    Types.VANQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<Types.VANQuery, Types.VANQueryVariables>(
    VANDocument,
    options
  );
}
export type VANQueryHookResult = ReturnType<typeof useVANQuery>;
export type VANLazyQueryHookResult = ReturnType<typeof useVANLazyQuery>;
export type VANQueryResult = Apollo.QueryResult<
  Types.VANQuery,
  Types.VANQueryVariables
>;
